var _defs, _path, _path2, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Degradado_sin_nombre_369-2);\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .cls-2 {\n        fill: url(#Degradado_sin_nombre_369);\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-10);\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19 {\n        stroke-width: 0px;\n      }\n\n      .cls-5, .cls-12 {\n        fill: #606060;\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-16 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-8 {\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-9 {\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-10 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-11 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-12 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-13 {\n        fill: #f9d656;\n      }\n\n      .cls-14 {\n        fill: #e1991c;\n      }\n\n      .cls-15 {\n        fill: #fdebb6;\n      }\n\n      .cls-17 {\n        fill: #eeae1a;\n      }\n\n      .cls-18 {\n        fill: #fbde7f;\n      }\n\n      .cls-19 {\n        fill: #f1bb16;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_369",
    "data-name": "Degradado sin nombre 369",
    x1: 3,
    y1: 16.27,
    x2: 38.81,
    y2: 16.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#fff",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_369-2",
    "data-name": "Degradado sin nombre 369",
    x1: 12919.38,
    y1: 45.39,
    x2: 12964.04,
    y2: 45.39,
    gradientTransform: "translate(12977.38) rotate(-180) scale(1 -1)",
    xlinkHref: "#Degradado_sin_nombre_369"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.58,
    dy: 6.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 12.26
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb600",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 6.86
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a56f16",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 6.86
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a56f16",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.68,4.87c-.39-.2-.87-.16-1.22.1L3.47,15.29c-.3.22-.47.57-.47.94,0,.37.17.72.47.94l13.98,10.38c.35.26.83.3,1.22.11.39-.2.64-.6.64-1.04v-4.22h18.32c.31,0,.61-.12.83-.34.22-.22.34-.52.34-.83v-9.93c0-.31-.12-.61-.34-.83-.22-.22-.52-.34-.83-.34h-18.32v-4.22c0-.44-.25-.84-.64-1.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.32,34c.39-.2.87-.16,1.22.1l13.98,10.32c.3.22.47.57.47.94,0,.37-.17.72-.47.94l-13.98,10.38c-.35.26-.83.3-1.22.11-.39-.2-.64-.6-.64-1.04v-4.22s-18.32,0-18.32,0c-.31,0-.61-.12-.83-.34-.22-.22-.34-.52-.34-.83v-9.93c0-.31.12-.61.34-.83.22-.22.52-.34.83-.34h18.32s0-4.22,0-4.22c0-.44.25-.84.64-1.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m23.04,33.17l-1.21-.58.04.02h0c-.12-.06-.25-.12-.38-.17-.03-.01-.05-.02-.08-.04-.08-.03-.16-.07-.24-.1,0,0-.02,0-.02,0-.04-.02-.08-.03-.12-.05h0c-.21-.08-.42-.16-.64-.23h0c-.13-.04-.26-.08-.39-.12-.03,0-.05-.02-.08-.02-.13-.03-.26-.07-.39-.1h0c-.29-.07-.59-.13-.89-.18h0c-.46-.07-.93-.12-1.41-.13-.13,0-.25,0-.38,0-.1,0-.2,0-.31,0-.03,0-.07,0-.1,0-.07,0-.13,0-.2,0-.04,0-.08,0-.12,0-.06,0-.12,0-.18.01-.04,0-.09,0-.13.01-.06,0-.12,0-.17.02-.04,0-.09,0-.13.01-.06,0-.11.01-.17.02-.04,0-.09.01-.13.02-.05,0-.11.02-.16.02-.04,0-.09.01-.13.02-.05,0-.11.02-.16.03-.04,0-.09.02-.13.02-.05.01-.11.02-.16.03-.04,0-.09.02-.13.03-.05.01-.11.02-.16.04-.04,0-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.08.02-.13.04-.05.02-.11.03-.16.05-.04.01-.08.02-.12.04-.06.02-.11.04-.16.05-.04.01-.08.03-.12.04-.06.02-.12.04-.18.06-.03.01-.07.02-.1.04-.08.03-.16.06-.24.09h-.03c-.73.3-1.42.66-2.08,1.08h0c-.25.16-.5.33-.74.51h0c-.24.18-.47.36-.7.56h0c-2.38,2.03-4.06,4.92-4.55,8.19h0c-.02.12-.03.23-.05.35h0c-.01.12-.03.23-.04.34v.04c-.01.1-.02.2-.03.3,0,.02,0,.04,0,.06,0,.12-.01.23-.02.35h0c0,.12,0,.24,0,.36-.01.8.05,1.59.18,2.35h0c.01.09.03.17.05.25,0,.04.02.08.02.12.02.08.03.17.05.25,0,.03.01.05.02.07.04.16.08.32.12.48,0,.04.02.07.03.11.02.08.05.16.07.24.01.04.02.07.03.11.05.17.11.34.17.51v.02c.04.08.07.16.1.24.01.04.03.07.04.11.03.08.06.16.1.23l.02.04c.07.16.14.31.21.46.01.03.03.06.04.09.04.07.07.15.11.22.02.03.03.06.05.09.08.15.16.3.25.45l.02.03c.04.07.09.14.13.22.02.03.04.06.06.09.04.07.09.14.14.21h0c.26.4.54.78.85,1.14h0s.03.03.04.04c.04.04.07.08.11.12.05.06.1.12.15.17h0c.1.11.2.22.31.33h0c.1.11.21.22.31.32h.01c.06.07.12.12.18.18,0,0,.01,0,.02.01.05.04.09.08.14.12h0c.17.15.35.29.52.43h0s.03.02.05.04c.03.02.05.04.08.06.04.03.07.05.11.08.03.02.05.04.08.06.04.03.07.05.11.08.03.02.05.04.08.06.06.04.13.09.19.13.03.02.07.04.1.06.06.04.12.08.19.12.09.06.18.11.28.17.04.02.08.05.12.07.07.04.15.08.23.12.04.02.07.04.11.06.11.06.22.11.34.17h0s-.01,0-.01,0l1.21.58c1.51.73,3.2,1.13,5,1.13,6.74,0,12.43-5.65,12.72-12.63.21-5.11-2.54-9.51-6.68-11.5Zm-2.12,1.29h.02s.02.02.02.02h0s-.04-.02-.04-.02h0Zm-.89-.37s.07.02.1.04c.03.01.06.02.08.03,0,0,0,0,0,0-.03-.01-.06-.02-.09-.03-.03-.01-.06-.02-.09-.03Zm.67.27s.04.02.06.03h0s-.04-.02-.07-.03Zm.51.25h0s.04.02.06.03c-.02-.01-.04-.02-.06-.03Zm-1.59-.65h0s.07.02.1.03c0,0,0,0,0,0-.04-.01-.07-.02-.11-.03Zm-.76-.2h0s.08.02.11.03c0,0,0,0,0,0-.04,0-.08-.02-.12-.03Zm-.78-.14s-.06,0-.08-.01c.03,0,.06,0,.09.01.04,0,.08.01.12.02h0s-.08-.01-.12-.02Zm-.41-.05s-.02,0-.02,0c0,0,.01,0,.02,0h0Zm.16.02s.03,0,.05,0c.01,0,.02,0,.03,0-.03,0-.05,0-.08,0Zm7.08,4.44l-.02-.03h0s.02.03.02.03h0Zm.16.27s.02.03.03.05h0s-.02-.04-.02-.04h0Zm.52.99v-.02s-.01,0-.01,0c0,0,0,0,0,0v.02s.05.08.06.12c-.02-.04-.03-.08-.05-.12Zm-.14-.3s.04.08.05.11c-.02-.04-.04-.08-.05-.11-.01-.03-.02-.05-.04-.08.01.02.02.05.03.07h0Zm-.79-1.32s.02.03.03.04c0-.01-.02-.03-.03-.04h0Zm-2.19-2.25s0,0,0,0h0s0,0,0,0Zm1.59,1.48s-.01-.01-.02-.02c0,0,.01.01.02.02h0Zm-.54-.58h0s0,0,.01.01c0,0,0,0-.01-.01Zm.95,1.09h0s0,0,0,0l.03.04c.04.06.09.12.13.18-.04-.06-.09-.12-.13-.18-.01-.02-.02-.03-.03-.05Zm-1.22-1.34s-.06-.05-.08-.07c.03.03.06.05.09.08l.02.02-.02-.02Zm-.23-.2s-.02-.02-.03-.03c-.08-.07-.16-.14-.24-.2l-.03-.02.03.02c.08.07.16.13.24.2.01,0,.02.02.03.03Zm-.86-.66h-.01s0,0,0,0h.01s0,.01,0,.01c0,0,0,0,0,0Zm-.59-.37h0s0,0,0,0h0Zm-1.58-.73s-.01,0-.02,0c-.02,0-.04-.01-.06-.02.02,0,.04.01.06.02,0,0,.02,0,.02,0h0Zm-2.71-.54s.07,0,.11,0h0s-.08,0-.11,0c-.06,0-.11,0-.17,0-.03,0-.07,0-.1,0-.04,0-.08,0-.12,0,.04,0,.08,0,.13,0,.03,0,.06,0,.09,0,.06,0,.12,0,.18,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.42,34.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.74,34.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.83,54.29h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.45,40.38l1.6-2.87c-.17.24-.34.49-.49.74-.42.68-.79,1.39-1.1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.08,43.77v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.6,33.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.21,54.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.12,34.09h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.85,33.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m10.09,52.84h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.06,53.49l-.03-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m10.4,53.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.47,54.16h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m8.77,51.65l-.04-.04.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.77,48.43s-.02-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.94,48.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.85,48.64v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m8.55,51.4s-.04-.04-.05-.06c.02.02.04.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m7.03,49.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.09,35.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.93,52.09l-.03.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "26.09 39.92 26.08 39.91 26.09 39.92 26.09 39.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m24.32,50.6h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m23.51,51.53l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "24.44 37.02 24.42 36.99 24.42 36.99 24.42 36.99 24.44 37.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "22.89 35.48 22.92 35.5 22.89 35.48 22.88 35.48 22.88 35.48 22.89 35.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m24.25,36.78h0s.05.06.07.08c-.02-.03-.05-.06-.07-.08-.01-.02-.03-.03-.04-.05.01.02.03.03.04.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m25.92,47.84s-.02.04-.03.06c0-.02.02-.04.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.64,35.29s-.03-.02-.05-.03c-.09-.06-.17-.13-.26-.19.09.06.18.12.26.19.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m23.7,36.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m23.22,35.76c.07.06.14.12.2.18l.04.04h0s0,0,0,0c.04.04.08.07.12.11h0s-.08-.07-.13-.11l-.04-.04c-.07-.06-.13-.12-.2-.18-.02-.02-.04-.03-.06-.05-.08-.07-.16-.14-.25-.2.08.07.17.13.25.2.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.66,42.34s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.48,41.25s.01.05.02.08c0-.03-.01-.05-.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.56,41.64v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.3,40.55s.01.05.02.07c0-.02-.01-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.4,40.93s0,.03.01.05c0-.02,0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.62,41.99s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.19,40.22s.02.06.03.08c0-.03-.02-.06-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.06,47.48h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.31,46.71h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.19,47.09v.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.41,46.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m25.85,39.33s-.03-.08-.05-.12v-.02s0,.02,0,.02c.02.04.04.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.07,43.67c0-.1.02-.2.03-.3,0,.1-.02.2-.03.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.48,31.8s.09-.02.13-.04c-.04.01-.09.02-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.05,44.09c0-.12.01-.24.02-.35,0,.12-.01.24-.02.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.1,43.34c.01-.11.02-.22.04-.33-.01.11-.03.22-.04.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.27,47.09c-.02-.09-.03-.17-.05-.26.01.09.03.17.05.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.35,47.46c-.02-.08-.04-.17-.05-.25.02.08.03.17.05.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.14,43c.01-.12.03-.23.05-.35-.02.12-.03.23-.05.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.63,32.08s.07-.02.1-.04c-.03.01-.07.02-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.91,31.98s.08-.03.12-.04c-.04.01-.08.03-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.2,31.89s.08-.03.12-.04c-.04.01-.08.03-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.36,32.19h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m9.51,33.79c.24-.18.49-.35.75-.51-.25.16-.5.33-.75.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.61,54.51h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.49,48.02c-.04-.16-.08-.32-.12-.49.04.16.08.33.12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m7.86,53.7c-.11-.1-.21-.2-.32-.31.1.11.21.21.32.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m9.74,55.14c-.06-.04-.13-.08-.19-.12.06.04.13.08.19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m7.54,53.38c-.1-.11-.21-.22-.31-.33.1.11.2.22.31.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.59,48.38c-.02-.08-.05-.16-.07-.24.02.08.05.16.07.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m10.48,55.56s-.07-.04-.11-.06c.04.02.07.04.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m10.14,55.38s-.08-.05-.12-.07c.04.02.08.05.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.06,51.55c-.05-.07-.09-.14-.14-.22.05.07.09.14.14.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.03,49.61c-.03-.08-.06-.16-.1-.24.03.08.06.16.1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.72,50.99c-.09-.15-.17-.3-.25-.46.08.16.17.31.25.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.79,49c-.06-.17-.12-.34-.17-.51.05.17.11.34.17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m4.89,49.26c-.03-.08-.06-.16-.09-.24.03.08.06.16.09.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.42,50.44c-.04-.07-.08-.15-.11-.23.04.08.07.15.11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.26,50.12c-.07-.15-.14-.31-.21-.47.07.16.14.32.21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m8.79,34.35c.23-.2.47-.38.71-.56-.24.18-.48.37-.71.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.5,56.76c-.13.02-.26.03-.4.05.13-.01.26-.03.4-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.1,56.81c-.12.01-.24.02-.36.03.12,0,.24-.02.36-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.38,55.99s.05.02.07.03c.07.03.14.06.22.09-.07-.03-.14-.06-.22-.09-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m21.64,32.29c.13.06.26.12.38.18-.13-.06-.25-.12-.38-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.89,56.7c-.12.02-.24.04-.36.06.12-.02.24-.04.36-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m21.5,55.5c-.09.05-.18.09-.27.13.09-.04.18-.09.27-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.64,56.85c-.09,0-.19.01-.28.01.09,0,.19,0,.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.22,54.76h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.96,56.21s.08.03.12.04c.05.02.09.03.14.05-.05-.02-.09-.03-.14-.05-.04-.01-.08-.03-.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.4,54.67h-.04s.04,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.1,56.74c-.06,0-.12-.02-.18-.03-.05,0-.09-.02-.14-.02.05,0,.09.02.14.02.06,0,.12.02.18.03.05,0,.09.01.14.02.06,0,.12.02.18.02-.06,0-.12-.01-.18-.02-.05,0-.09-.01-.14-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.26,56.58s.03,0,.05.01c.03,0,.06.01.09.02-.03,0-.06-.01-.09-.02-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.56,56.4s-.06-.02-.09-.03c.03,0,.06.02.09.03.04.01.09.03.13.04.06.02.11.03.17.05-.06-.02-.11-.03-.17-.05-.04-.01-.09-.02-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.92,31.3h0c.13,0,.26,0,.39,0-.13,0-.26,0-.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.65,31.52s.09-.02.14-.02c-.05,0-.09.02-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.95,31.47s.09-.01.14-.02c-.05,0-.09.01-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.12,31.74c.13.04.27.08.4.12-.13-.04-.26-.08-.4-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.25,31.42s.09-.01.14-.02c-.05,0-.09.01-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.06,31.65s.09-.02.13-.03c-.04.01-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.36,31.58s.09-.02.13-.03c-.04,0-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.56,31.38s.09-.01.13-.01c-.04,0-.09,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.74,31.44c.31.05.61.11.9.18-.3-.07-.6-.13-.9-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.77,31.72s.09-.02.13-.03c-.04.01-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.65,31.62c.13.03.26.06.39.1-.13-.04-.26-.07-.39-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.18,31.33s.08,0,.12,0c-.04,0-.08,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.51,31.31s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.87,31.35s.09,0,.13-.01c-.04,0-.09,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.87,51.24c-.04-.07-.09-.15-.13-.22.04.07.09.15.13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m24.9,37.64c.05.08.1.15.15.23l.03.04h0s.02.03.02.03h0s0,0,0,0c.05.08.1.16.15.25h0s0,0,0,0c.01.02.03.05.04.07h0s.05.09.08.14c.03.05.05.09.08.14h0c.05.1.1.2.15.29h0s.02.05.03.07l1.18-2.12-.03-.04-.03-.04c-.07-.11-.14-.21-.21-.32-.02-.03-.04-.05-.06-.08-.06-.09-.13-.18-.19-.27-.01-.02-.03-.04-.04-.06-.04-.05-.08-.11-.12-.16l-1.12,2.01c-.04-.06-.08-.13-.13-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.08,45.31h0s0,.03,0,.05c0-.02,0-.03,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "6.35 47.09 6.36 47.12 6.35 47.09 6.35 47.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m27.46,37.9s-.03-.06-.05-.09c-.02-.04-.04-.07-.06-.11.02.04.04.07.06.11.02.03.03.06.05.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m28.23,39.88v.04s0-.04,0-.04c-.03-.11-.06-.21-.1-.32-.01-.03-.02-.06-.03-.09.01.03.02.06.03.09.03.11.07.21.1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.05,44.73h0s0,.01,0,.01c0,.03,0,.05,0,.08,0-.03,0-.05,0-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.06,44.09h0c0,.09,0,.18,0,.28,0-.09,0-.18,0-.28h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "25.98 35.61 25.98 35.61 25.95 35.57 25.98 35.61 25.98 35.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.77,33.43h0,0s-.06,0-.1,0c.03,0,.06,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.56,47.83s-.01-.03-.02-.05c.02.07.05.15.07.22-.02-.06-.04-.11-.06-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.66,48.14h0s.02.05.03.07c0-.02-.02-.05-.03-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.46,47.5c.03.09.05.19.08.28h0s0,0,0,0c-.03-.09-.06-.18-.08-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m24.81,34.37l-.02-.02s-.08-.07-.12-.11c.04.04.08.07.12.11l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.44,47.43h0s.01.05.02.07c0-.02-.01-.05-.02-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m23.49,33.32h-.02c-.07-.06-.14-.1-.2-.15.07.04.14.09.2.13h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.83,34.23s.05.02.07.03c-.03-.01-.05-.02-.07-.03-.05-.02-.1-.04-.15-.06h.02s.09.04.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.41,32.66s-.06-.03-.09-.05c-.05-.03-.1-.05-.15-.08.05.03.1.05.15.08.03.02.06.03.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.6,52.37c-.06.05-.11.09-.17.14-.31.24-.63.47-.97.68-.06.03-.11.07-.17.1-.21.13-.43.25-.65.36l-1.55,2.78c-.38.1-.77.19-1.16.26,1.15-.2,2.26-.56,3.29-1.06-.19.09-.39.18-.59.27l1.96-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.67,56.87l1.18-2.12c-.29.03-.59.04-.89.04-.12,0-.23,0-.34,0l-1.12,2.01s.05,0,.07,0c.06,0,.12.01.19.02.05,0,.09,0,.14.01.06,0,.13,0,.2.01.04,0,.09,0,.13,0,.07,0,.15,0,.22,0,.04,0,.07,0,.11,0,.11,0,.22,0,.33,0,.13,0,.25,0,.38,0-.13,0-.25,0-.38,0-.07,0-.14,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.59,34.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.91,34.27h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m21.99,34.85h0s.05.03.07.04c-.02-.01-.05-.03-.07-.04l-.04-.02.04.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "21.71 34.68 21.71 34.68 21.71 34.68 21.72 34.69 21.71 34.68 21.68 34.66 21.71 34.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.98,33.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.32,33.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.93,33.45s.04,0,.06,0c-.02,0-.04,0-.06,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m28.64,41.8v-.04s-.01-.07-.02-.1c0,.03,0,.07.01.1v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.58,33.54h0s.09.02.14.03c.04,0,.08.02.12.02.04,0,.07.02.11.02h.01s-.08-.02-.12-.02c-.04,0-.08-.02-.12-.02-.05,0-.1-.02-.14-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.46,33.52s.08.01.12.02c-.04,0-.08-.01-.12-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m26.74,43.54c0,.18,0,.37,0,.55-.01.34-.04.67-.09,1.01l1.96-3.53s.01.06.02.09c-.02-.11-.03-.23-.05-.34,0-.03,0-.06-.01-.08-.02-.13-.05-.26-.08-.4,0-.03-.01-.06-.02-.09-.02-.11-.05-.22-.08-.33,0-.03-.01-.06-.02-.09-.03-.13-.07-.25-.1-.38l-1.55,2.79c.02.26.03.53.03.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m28.73,42.7c0,.06,0,.12,0,.17l-2.98,5.37c-.25.56-.55,1.1-.89,1.61-.02.03-.04.05-.05.08l-3,5.4c-.09.05-.19.1-.28.15,4.09-2.11,7.01-6.42,7.21-11.4,0-.14,0-.29,0-.43,0-.04,0-.07,0-.11,0-.13,0-.26,0-.38v-.04c0-.14-.01-.28-.02-.42,0-.04,0-.07,0-.11,0-.08-.01-.16-.02-.24,0,.08.01.16.02.24,0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "21.06 34.34 21.08 34.35 21.06 34.34 21.06 34.34 21.06 34.34 21.06 34.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.22,38.06c.54-1,1.23-1.92,2.03-2.72l.55-.98c-2.41,2.05-4.11,4.98-4.61,8.29l.94-1.69c.22-1.01.59-1.98,1.09-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.14,33.41c.23-.02.46-.02.7-.02h.03s.08,0,.12,0c.04,0,.08,0,.13,0,.03,0,.06,0,.09,0,.06,0,.12,0,.18,0,.04,0,.07,0,.11,0h0s0,0,0,0h.03s.07,0,.11,0l1.1-1.98c-.47-.07-.94-.12-1.43-.13l-1.17,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m8.02,50.73v-.02s-.06-.07-.09-.11h-.01s0-.02,0-.02h0s-.03-.04-.04-.06c-.03-.04-.06-.08-.08-.13-.01-.02-.03-.04-.04-.06l-.02-.03-.02-.03h0s-.03-.04-.04-.06l-.02-.02s-.02-.03-.03-.05c-.01-.02-.03-.05-.04-.07l-.02-.03s-.02-.04-.03-.06l-.02-.04s-.05-.08-.07-.12v-.02s-.03-.02-.03-.02h0s-.02-.03-.02-.03c-.03-.06-.07-.12-.1-.18v-.02s-.04-.05-.05-.07v-.02s-.02-.01-.02-.01l-1.17,2.1c.35.53.74,1.03,1.16,1.5-.1-.11-.2-.23-.3-.35l1.1-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m11.39,33.09c.2-.1.41-.19.62-.28l.35-.62c-.73.3-1.44.66-2.1,1.08l-.4.71c.49-.34,1-.64,1.54-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m10.82,55.74h0s0,0,0,0c.03.02.07.03.1.05-.03-.02-.07-.03-.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m9.77,52.59l-.03-.02h0s-.04-.04-.06-.05l-.03-.03s-.09-.07-.13-.11c-.02-.01-.03-.03-.05-.04l-.04-.03-.04-.03s-.06-.06-.09-.09l-.04-.04-.02-.02-1.04,1.88c-.11-.1-.23-.2-.34-.3.49.46,1.01.87,1.57,1.24-.24-.16-.48-.33-.7-.5l1.03-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m6.11,43.44c.32-3.2,1.98-6.02,4.36-7.85h0s1.24-2.24,1.24-2.24c-.05.03-.1.05-.14.08-.51.29-1.01.6-1.47.96-.29.21-.56.44-.83.67l-5.22,9.4h0c-.01.81.05,1.61.18,2.38l1.89-3.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.36,33.71s-.08-.02-.11-.03c-.05-.01-.09-.02-.14-.03.05.01.1.02.14.03.04,0,.08.02.11.03.05.01.1.03.14.04.04.01.07.02.11.03h0s0,0,0,0c.05.01.09.03.14.04h0s.07.02.11.03c.05.02.1.03.15.05.03.01.07.02.1.03.05.02.11.04.16.06.03.01.06.02.08.03-.03-.01-.06-.02-.08-.03-.05-.02-.09-.03-.14-.05l1.03-1.86c.13.05.26.1.39.16-.34-.15-.68-.28-1.03-.39l-1.05,1.88s-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m24.81,49.94s.04-.05.05-.08c-.02.03-.04.05-.05.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 26.05,
    y: 47.49,
    width: 0.01,
    height: 0,
    transform: "translate(-27.48 55.74) rotate(-70.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m8.5,51.34s.04.04.05.06h0s-.04-.04-.05-.06h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 26.41,
    y: 46.32,
    width: 0.01,
    height: 0,
    transform: "translate(-24.84 61.02) rotate(-76.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.56,40.35s0,.03,0,.05h0s0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m26.18,47.13v-.04s0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.89,47.91s.02-.04.03-.06h0s-.02.04-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.75,48.24h0c-.25.56-.55,1.1-.89,1.61.34-.51.63-1.05.89-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.3,38.26s.05.09.08.14c-.03-.05-.05-.1-.08-.14l-.02-.04.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.58,40.5s0,.04,0,.06h0s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.73,45.11s-.03,0-.05,0c.02,0,.04,0,.06,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.57,45.09s.04,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.82,45.12h-.04s.04,0,.06,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.07,45.2s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.88,45.14s.04,0,.05.01c-.02,0-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.97,45.16s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.18,45.24h-.02s.03,0,.05.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.58,40.65s0,.06,0,.09h0s0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.59,40.81c0,.05,0,.1,0,.15h0c0-.05,0-.1,0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.44,45.08s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m8.01,50.71s-.05-.07-.08-.11c.03.04.05.07.08.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 24.32,
    y: 50.61,
    width: 0,
    height: 0,
    transform: "translate(-30.51 38.52) rotate(-51.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 26.3,
    y: 46.71,
    width: 0,
    height: 0,
    transform: "translate(-25.63 60) rotate(-74.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.37,39.47s.02.05.02.07h0s-.02-.04-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.32,39.34s.01.03.02.05v.02s0-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m26.08,39.91h0s0,0,0,0h0s0,0,0,0l-.02-.04s-.03-.08-.04-.11v-.04s.03.1.04.15c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.27,39.2v.04s.02.02.02.02c0-.02-.02-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.51 39.98 20.51 39.99 20.5 39.96 20.51 39.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.49 39.9 20.49 39.91 20.49 39.92 20.49 39.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.65,38.91c.04.07.07.15.11.22-.03-.07-.07-.15-.11-.22-.01-.03-.03-.05-.04-.08h0s.03.05.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.21,39.07v.02s.02.02.02.02c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m25.9,39.45s-.02-.05-.03-.07c0-.02-.01-.03-.02-.05.02.04.04.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m24.64,37.27l.02.03s.02.03.03.05c-.01-.02-.02-.03-.03-.05l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.47,39.81v.04s0-.06-.01-.09c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.64,53.65c.22-.11.44-.23.65-.36-.21.13-.43.25-.65.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.43,52.51c-.31.24-.63.47-.97.68.33-.21.66-.44.97-.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "22.9 52.12 22.93 52.09 22.9 52.12 22.9 52.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m22.6,52.37h0c-.06.05-.11.09-.17.14.06-.04.11-.09.17-.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 23.49,
    y: 51.54,
    width: 0.02,
    height: 0,
    transform: "translate(-29.66 31.99) rotate(-45.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.53 40.14 20.54 40.14 20.53 40.14 20.53 40.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "22.66 35.31 22.66 35.31 22.63 35.28 22.66 35.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.19 39.03 20.19 39.04 20.19 39.02 20.19 39.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.54 40.2 20.55 40.23 20.55 40.24 20.54 40.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.15 38.94 20.15 38.95 20.16 38.98 20.15 38.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "16.2 45.08 16.19 45.07 16.22 45.08 16.2 45.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.52 40.05 20.52 40.07 20.52 40.08 20.52 40.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.69,48.22s.04.06.06.09c-.02-.03-.04-.07-.07-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.06,44.94s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.66,48.14s.02.05.03.07c0,.02.02.04.02.06v-.04s-.04-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.41,47.23s0-.09,0-.13c0,.05,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 6.08,
    y: 45.59,
    width: 0.04,
    height: 0,
    transform: "translate(-6.68 1.41) rotate(-8.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.76,48.33s.02.03.03.05l.03.03s-.04-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.35,48.87s.05.03.08.04h.02s-.07-.02-.11-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.94,48.54s.03.03.05.05l.03.03s-.05-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.84,48.43s.05.06.08.09c-.03-.03-.05-.06-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.03,48.63s.06.05.09.08h0s-.06-.05-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.27,48.82s.05.03.08.05c-.03-.02-.07-.04-.1-.06l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.13,48.72s.06.04.09.07c-.03-.02-.06-.04-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.56,47.85h0s0-.02,0-.02c.02.06.04.11.06.17v.04c0-.06-.02-.11-.04-.17v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.77,48.42s-.01-.04-.02-.05h0s.01.04.02.06c0,.02.02.04.02.06v-.02s-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "7.73 50.31 7.75 50.34 7.74 50.32 7.73 50.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "7.41 49.78 7.41 49.78 7.41 49.78 7.41 49.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.58,50.08s.03.05.04.07c-.01-.02-.02-.04-.03-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "7.66 50.2 7.67 50.22 7.67 50.22 7.66 50.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.44,49.83s.05.08.07.12c-.02-.03-.04-.07-.06-.1l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.37,49.71s-.02-.04-.03-.05c-.02-.03-.03-.06-.05-.09.03.06.07.12.1.18v-.03s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.82,48.55h0s.02.03.03.05v.03s.02.02.02.02c0-.02-.02-.04-.02-.05,0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m6.91,48.77s.02.04.03.06h0s.01.04.01.04c-.01-.03-.03-.06-.04-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.02,49.02v.02s.01,0,.01,0l.02.04h0s-.02-.05-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.24,49.48s.03.05.04.07v-.03s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 12.83,
    y: 54.28,
    width: 0,
    height: 0.02,
    transform: "translate(-42.71 49.12) rotate(-71.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 8.75,
    y: 51.6,
    width: 0,
    height: 0.06,
    transform: "translate(-32.5 19.38) rotate(-42.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 13.21,
    y: 54.4,
    width: 0,
    height: 0,
    transform: "translate(-42.74 52.46) rotate(-74.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "15.6 44.99 15.57 44.98 15.61 44.99 15.6 44.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "14.36 54.66 14.4 54.67 14.4 54.67 14.36 54.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.38,44.93s-.03,0-.05-.01c.03,0,.05.02.08.02h-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 13.59,
    y: 54.49,
    width: 0,
    height: 0.03,
    transform: "translate(-42.58 54.46) rotate(-75.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 10.08,
    y: 52.83,
    width: 0,
    height: 0.02,
    transform: "translate(-38.29 29.32) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "16.01 45.06 16 45.06 16.01 45.06 16.01 45.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.79,45.03h-.03s.04,0,.05,0h-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "12.45 54.15 12.47 54.16 12.47 54.16 12.45 54.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 11.05,
    y: 53.46,
    width: 0,
    height: 0.04,
    transform: "translate(-40.69 36) rotate(-59.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.44,47.56s.01.07.02.11c0-.04-.02-.07-.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.51,47.84v.04s.03.04.04.05c-.01-.03-.02-.06-.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.47,47.69h0s.02.08.03.12c-.01-.04-.02-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.62,48.09s.03.06.05.09c-.02-.03-.03-.06-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.56,47.96s.03.07.05.11c-.02-.04-.04-.07-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.12,38.9v.02s0-.03-.02-.05l.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.03,44.81h0s-.05-.02-.08-.03c.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.42,47.4s0,.07.01.1v.02s0-.08-.01-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 15.2,
    y: 54.74,
    width: 0,
    height: 0.03,
    transform: "translate(-40.56 65.74) rotate(-85.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.22,44.88h-.02s-.04-.02-.06-.03h0s.06.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.42,47.39s0-.08,0-.12c0,.04,0,.08,0,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "9.4 52.27 9.44 52.31 9.44 52.31 9.4 52.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m7.87,50.52l-.02-.03s-.04-.06-.06-.08c.03.04.06.08.08.13h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.06,43.97s.05.04.07.06c-.03-.03-.06-.06-.1-.09h0s.03.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.16,44.06s.08.08.12.12c-.04-.04-.08-.08-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.5,44.44v.02s-.05-.08-.08-.11c.02.03.05.06.07.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.6,44.58l.03.04s-.07-.09-.1-.14c.02.03.04.06.06.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.94,45.16s.04.08.06.12c-.02-.04-.04-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.02,45.33c.02.05.04.11.06.16-.02-.05-.04-.11-.06-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.3,44.21s.06.07.09.1c-.03-.03-.06-.07-.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.84,44.96c.03.05.05.1.08.15-.03-.05-.05-.1-.08-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.85,38.45s.04.05.05.08c-.02-.03-.04-.05-.05-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "18.91 43.83 18.88 43.81 18.9 43.82 18.91 43.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.03,38.98s.04,0,.06.01c-.02,0-.04,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.99,38.66h0s-.04-.05-.06-.08c.02.03.03.05.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.78,43.73s-.03-.02-.05-.04l.03.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.86,43.79s-.05-.04-.07-.06l.02.02s.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.09,45.51s.03.1.05.14c-.02-.05-.03-.1-.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.13,39s.04,0,.05.01c-.02,0-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.99,43.9s-.05-.04-.08-.06l.03.02s.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.23,39.03s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.27,46.17s0,.04.01.06c0-.05-.02-.09-.03-.14,0,.03,0,.05.01.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.79,44.87s.03.06.05.09c-.03-.05-.06-.1-.09-.15,0,.02.02.03.03.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.44,39.71s-.02-.06-.03-.09c0,.03.02.06.03.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.66,40.97s0,.08,0,.12h0s0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.2,37.74s.05.04.08.07c-.03-.02-.05-.04-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.05,38.77v.02s-.02-.05-.03-.08c.01.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "20.08 38.81 20.08 38.82 20.09 38.84 20.08 38.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.96,37.56s.05.04.07.05c-.02-.02-.05-.04-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.52,37.29s.04.02.06.03h.01s.04.03.06.04c-.04-.03-.09-.05-.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.28,47.63c-.02.1-.04.2-.06.3.02-.1.05-.2.06-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.29,46.29c0,.05.01.1.02.15,0-.05-.01-.1-.02-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.31,46.48c0,.06.01.12.01.18,0-.06,0-.12-.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.2,45.88c.01.06.03.12.04.17-.01-.06-.03-.12-.04-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m17.43,39.11h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.7,44.73l.03.04s-.05-.07-.07-.11c.01.02.02.03.03.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.15,45.71s.03.09.04.13c-.01-.05-.02-.09-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.33,46.71s0,.1,0,.14c0-.05,0-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m20.33,46.91c0,.06,0,.13,0,.19,0-.06,0-.13,0-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.67,43.65h.02s-.07-.04-.11-.06l.03.02s.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.66,41.22v.03s0,0,0,0c0-.03,0-.06,0-.09,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.26,42.48s-.05-.05-.07-.07c.02.03.05.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.42,37.95s.03.03.05.05h0s-.04-.03-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.18,42.39s-.05-.06-.08-.09c.03.03.05.06.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m9.31,52.19s.06.06.09.09c-.03-.03-.06-.06-.09-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.35,42.56h0s-.05-.04-.07-.06c.02.02.04.04.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15.08,42.28s-.04-.05-.06-.08c.02.03.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.67,38.22v.02s.05.04.05.04c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 15.47,
    y: 42.65,
    width: 0,
    height: 0,
    transform: "translate(-28.27 30.6) rotate(-54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.83,41.87v.02s.02.02.02.02c0-.02-.02-.03-.02-.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m15,42.18s-.04-.07-.07-.1c.02.03.04.07.07.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.79,41.78s-.01-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "19.57 38.1 19.57 38.11 19.56 38.09 19.57 38.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.74,41.62h0s0,.03,0,.03c0-.02-.01-.04-.02-.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.58,38.11h.01s.03.05.03.05c-.02-.02-.03-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m9.75,52.57l.03.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "19.48 38.01 19.49 38.02 19.52 38.05 19.48 38.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.89,41.99h0s.02.04.03.06c-.01-.02-.03-.05-.04-.08v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.68,41.37h0s0,.02,0,.02c0-.03,0-.05-.01-.08,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "18.39 43.47 18.37 43.46 18.37 43.46 18.39 43.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.83,37.47s.05.04.08.05c-.03-.02-.05-.04-.08-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "19.38 37.91 19.38 37.91 19.41 37.94 19.38 37.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.08,37.65s.05.04.07.06c-.02-.02-.05-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.93,38.97s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.69,38.95s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.82,38.96s.05,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.52,43.55h.02s-.1-.05-.15-.08c.02.01.04.02.06.04.02.01.05.03.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m16.84,54.75h0c-.29.03-.59.04-.89.04-.12,0-.23,0-.34,0,.11,0,.23,0,.34,0,.3,0,.6-.01.89-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m9.53,52.38h0s.08.07.13.11c-.04-.04-.09-.07-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.76,38.33h0s.03.05.04.07c-.02-.02-.04-.05-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m14.71,41.49v.03s0,0,0,0c0-.02-.01-.05-.01-.07v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.68,37.38h.02s0,.02,0,.02c.02.01.05.03.07.04-.03-.02-.06-.04-.1-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "19.66 38.21 19.66 38.21 19.66 38.21 19.66 38.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m18.34,43.44s-.06-.03-.09-.05c.02,0,.03.02.05.03l.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.37,37.9h0s-.04-.03-.07-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m21.71,34.68l-.04-.02c-1.12-.44-2.33-.68-3.62-.68-5.71,0-10.53,4.79-10.77,10.7-.02.37-.01.73,0,1.09-.03-.01-.06-.03-.09-.04.03.01.06.03.09.04.02.32.05.64.1.96,0,.04.01.07.02.11.11.69.28,1.36.52,2,1.56.94,3.45,1.48,5.5,1.48.11,0,.21,0,.32,0-.02-.01-.03-.03-.05-.04-.02-.02-.04-.04-.06-.05-.02-.01-.03-.03-.04-.04-.02-.02-.04-.04-.06-.06l-.02-.02c-.05-.05-.11-.11-.16-.17l-.02-.02s-.04-.05-.07-.08l-.03-.03s-.04-.05-.06-.08l-.03-.03s-.04-.06-.06-.08l-.02-.03s-.04-.06-.06-.09v-.02c-.13-.19-.24-.39-.33-.6h0c-.02-.05-.03-.09-.05-.13v-.02s-.04-.08-.05-.12h0c-.07-.24-.13-.47-.16-.71h0c-.03-.24-.05-.5-.04-.75h2.03l.25.12c-.03.76.35,1.43.94,1.77h0c.21.08.43.13.66.13s.46-.04.67-.12c.09-.03.18-.07.26-.12.06-.03.11-.06.16-.1.19-.13.35-.28.49-.46.04-.05.08-.11.11-.16.1-.17.19-.35.24-.54.04-.13.06-.26.08-.4,0-.03,0-.07,0-.1.01-.31-.04-.61-.16-.87-.02-.06-.05-.12-.08-.17-.17-.3-.41-.55-.7-.73-.21-.08-.43-.13-.67-.13-.59,0-1.14-.13-1.63-.37l-.25-.12.04.02s-.04-.02-.05-.03h-.01s-.08-.05-.12-.07h0c-.39-.22-.74-.5-1.04-.83l-.02-.02c-.11-.12-.21-.25-.3-.39h0c-.04-.08-.08-.14-.12-.2l-.02-.04c-.04-.07-.08-.14-.11-.21h0c-.04-.08-.07-.15-.1-.23v-.03c-.04-.07-.06-.13-.09-.2,0-.02-.01-.03-.02-.05-.15-.46-.22-.95-.2-1.47.08-1.86,1.35-3.43,3.01-3.93.05-.01.09-.03.14-.04v-.23s.05-1,.05-1h1.99l.25.12-.05,1.18c.15.05.3.12.44.19h.01s.03.02.03.02c-.03-.02-.06-.03-.09-.04l.25.12c1.35.65,2.25,2.07,2.18,3.74h-2.04l-.25-.12h0s0-.1,0-.15v-.03s0-.09-.01-.14v-.02s-.01-.09-.02-.13v-.02s-.02-.09-.04-.13v-.03c-.03-.09-.07-.18-.1-.26v-.02s-.05-.08-.07-.12h0s-.05-.09-.07-.13h0s-.05-.08-.08-.12h0c-.06-.08-.13-.16-.2-.22h0c-.1-.1-.21-.18-.33-.25-.21-.08-.43-.12-.66-.12-1.07,0-1.98.9-2.03,2.01-.03.76.35,1.42.94,1.76l.04.02h.01c.09.04.19.06.28.08h.02s.09.02.14.02h.03s.1,0,.15,0c.07,0,.13,0,.19,0,.02,0,.04,0,.06,0,.04,0,.09,0,.13.01.02,0,.05,0,.07,0,.04,0,.08,0,.11.02.03,0,.05,0,.08.01.04,0,.07.01.11.02.03,0,.05.01.08.02.03,0,.07.02.1.03.03,0,.05.01.08.02.03,0,.07.02.1.03.03,0,.05.02.08.02.03.01.07.02.1.04.02,0,.05.02.07.03.04.02.08.03.12.05.04.02.07.03.1.05.03.01.05.02.08.04l-.04-.02.25.12c1.35.65,2.25,2.09,2.18,3.75,0,.22-.04.44-.08.65,2.15-1.71,3.57-4.19,3.7-6.93.06-1.29-.17-2.53-.64-3.65v-.02s-.02-.04-.02-.04c-.03-.08-.07-.16-.1-.24,0-.02-.02-.04-.03-.06-.01-.02-.02-.04-.03-.07-.03-.07-.07-.14-.11-.21v-.02c-.05-.08-.1-.16-.14-.24-.01-.02-.03-.04-.04-.07-.05-.08-.1-.17-.15-.25h0c-.05-.09-.11-.18-.16-.26-.01-.02-.03-.04-.04-.06-.05-.07-.1-.14-.15-.22l-.02-.03c-.06-.08-.12-.16-.18-.24-.02-.02-.03-.04-.05-.06-.05-.07-.11-.13-.16-.19l-.03-.04s-.06-.07-.09-.1h.02c.09.07.17.12.26.18-.04-.03-.08-.05-.12-.08-.04-.03-.09-.06-.13-.09-.02-.02-.05-.03-.07-.04h0l-.04-.02c-.07-.04-.15-.09-.22-.13h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m23.7,36.2s.04.04.05.05c.06.06.12.13.19.19.02.02.03.03.05.05-.02-.02-.03-.03-.05-.05-.06-.06-.12-.13-.19-.19-.02-.02-.04-.04-.05-.05-.03-.03-.07-.07-.1-.1h0s.08.06.11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.92,50.59h.01c.03.05.05.09.08.12v.02s.02,0,.02,0c-.04-.05-.07-.1-.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m18.92,50.11c.12-.11.24-.23.35-.36-.11.13-.23.25-.35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m17.79,50.85h0c-.1.04-.2.08-.3.12h0c.27-.09.52-.22.76-.36-.15.09-.3.17-.46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.5,51.34s.04.04.05.06h0s-.05-.05-.07-.08l.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "14.7 50.9 14.69 50.89 14.72 50.91 14.7 50.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "17.16 51.73 17.18 51.07 17.21 51.06 17.18 51.07 17.16 51.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.73,51.6l.04.04h0s-.04-.04-.06-.06h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.52,49.97s-.05-.08-.07-.12c.02.03.04.07.06.1l.02.04v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.59,50.09s.02.04.03.05c.01.02.02.03.03.05v.02s-.04-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m17.34,51.02h0s.1-.03.14-.05h0s-.09.03-.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m9.53,52.38s.08.07.13.11c-.04-.04-.09-.07-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m8.28,51.08h.01s.03.05.05.07c-.02-.03-.05-.06-.07-.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m6.71,48.28v.02s0-.04-.01-.05v.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "6.91 48.77 6.91 48.77 6.91 48.77 6.91 48.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m12.11,54.01h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m6.79,48.47v.02s.02.03.03.05h0s-.02-.04-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m17.14,52.25v-.22s0,.22,0,.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "7.05 49.09 7.05 49.09 7.05 49.08 7.05 49.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.38,49.73v.03s.03.03.03.03h0s-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.74,50.32v.02s.04.04.05.06c.02.03.04.06.06.08-.04-.05-.07-.11-.11-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m15.19,51.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "14.84 50.96 14.84 50.95 14.87 50.97 14.84 50.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "10.07 52.83 10.09 52.84 10.1 52.85 10.05 52.81 10.07 52.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m18.79,50.22c-.13.11-.26.21-.4.3.14-.09.27-.19.4-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "11.37 53.66 11.4 53.67 11.39 53.67 11.37 53.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "6.57 47.87 6.56 47.85 6.56 47.85 6.57 47.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m9.44,52.31s-.09-.08-.13-.12c.03.03.06.06.09.09l.04.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m16.84,54.75h0c1.35-.12,2.63-.5,3.8-1.1.22-.11.44-.23.65-.36.06-.03.11-.07.17-.1.33-.21.66-.44.97-.68.06-.04.11-.09.17-.14.1-.08.2-.17.3-.25l.03-.02c.2-.17.39-.36.57-.54l.02-.02c.28-.29.55-.6.81-.92h0c.17-.22.33-.44.48-.67.02-.03.04-.05.05-.08.34-.51.63-1.05.89-1.61.05-.11.1-.22.14-.34,0-.02.02-.04.03-.06.05-.12.09-.23.13-.35h0c.04-.13.08-.25.12-.36v-.04c.05-.12.09-.25.13-.37h0c.04-.13.07-.26.1-.39h0c.1-.41.17-.82.23-1.23.04-.33.07-.67.09-1.01,0-.18.01-.37,0-.55,0-.27-.01-.53-.03-.79h0c0-.12-.02-.23-.03-.35,0-.02,0-.04,0-.06-.01-.1-.02-.19-.04-.28,0-.02,0-.04,0-.06-.02-.11-.04-.22-.06-.33v-.02c-.02-.1-.04-.2-.06-.3,0-.03-.01-.05-.02-.08-.02-.09-.04-.18-.06-.27,0-.02,0-.03-.01-.05-.03-.1-.06-.21-.09-.31,0-.02-.01-.05-.02-.07-.02-.08-.05-.16-.08-.24,0-.03-.02-.06-.03-.08-.03-.1-.07-.2-.1-.3h0s0-.01,0-.01h0s-.01-.04-.02-.05c-.02-.05-.04-.1-.06-.15-.02-.04-.03-.08-.05-.12,0-.02-.02-.04-.03-.07-.01-.03-.02-.05-.03-.08-.02-.04-.04-.08-.05-.12-.02-.04-.03-.08-.05-.12v-.02s-.03-.04-.04-.05c-.03-.07-.07-.15-.11-.22-.01-.03-.03-.05-.04-.08-.05-.09-.1-.19-.15-.28h0c-.03-.06-.05-.11-.08-.15-.03-.05-.05-.1-.08-.14l-.02-.04-.02-.04h0c-.05-.08-.1-.17-.15-.25h0s-.02-.03-.02-.03l-.03-.04c-.05-.08-.1-.15-.15-.23-.02-.02-.03-.04-.05-.07l-.03-.04c-.04-.06-.09-.12-.13-.18-.01-.02-.02-.03-.03-.05l-.02-.03s-.03-.03-.04-.05c-.04-.06-.09-.12-.14-.17-.01-.02-.03-.04-.04-.06h0s-.07-.09-.1-.13c-.02-.03-.05-.06-.07-.08h0s-.03-.04-.04-.05c-.06-.07-.13-.14-.19-.21l-.02-.02s-.03-.03-.05-.05c-.06-.06-.12-.13-.19-.19-.02-.02-.04-.04-.05-.05-.04-.04-.07-.07-.11-.11-.04-.04-.08-.08-.12-.11h0s-.04-.04-.04-.04c-.07-.06-.13-.12-.2-.18-.02-.02-.04-.04-.06-.05-.08-.07-.16-.14-.25-.2l-.03-.03h0c-.07-.06-.15-.12-.22-.17l-.03-.02-.03-.02c-.09-.06-.17-.13-.26-.19h-.01c-.08-.07-.17-.12-.26-.18h-.02s.06.06.09.09l.03.04c.05.06.11.13.16.19.02.02.03.04.05.06.06.08.12.16.18.24l.02.03c.05.07.1.14.15.22.01.02.03.04.04.06.06.08.11.16.16.25h0c.05.09.1.17.15.26.01.02.03.04.04.07.05.08.09.16.13.24v.02c.05.07.08.14.12.21.01.02.02.04.03.07,0,.02.02.04.03.06.04.08.07.16.1.24l.02.04v.02c.48,1.12.71,2.36.65,3.65-.13,2.75-1.55,5.22-3.7,6.93-.32,1.62-1.54,2.92-3.07,3.32l-.05,1.22h-1.99l-.25-.12h0l.05-1.18c-.13-.05-.26-.1-.39-.16l-.25-.12h.01s0,0,0,0c-.03-.01-.06-.03-.08-.04-.02,0-.04-.02-.05-.03-.03-.02-.06-.03-.09-.05l-.04-.02s-.08-.05-.12-.08c-.02-.01-.03-.02-.05-.03-.03-.02-.05-.03-.07-.05-.02-.01-.04-.03-.06-.04-.02-.02-.04-.03-.06-.05-.02-.01-.04-.03-.06-.05-.02-.02-.04-.03-.06-.05-.02-.02-.04-.03-.06-.05h0c-.11,0-.21,0-.32,0-2.05,0-3.94-.54-5.5-1.48.83,2.25,2.39,4.12,4.41,5.27.04.02.08.03.12.05h.03c.11.05.23.09.35.13h.01c.12.05.25.09.37.12h0c.12.04.24.07.37.1h.03c.25.07.5.12.76.16h.04c.26.05.52.08.78.1h.03c.13.01.26.02.39.02.11,0,.23,0,.34,0,.3,0,.6-.01.89-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m10.73,53.29h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.28,49.55v-.02s0,.03,0,.03v.02s.04.06.06.09c-.02-.04-.04-.07-.06-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m7.87,50.52h0s.03.04.04.06c-.01-.02-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m20.16,48.13c-.04.15-.1.3-.16.44.06-.14.11-.29.16-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m19.96,48.67c-.04.09-.08.17-.12.26.04-.08.09-.17.12-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m19.7,49.16c-.1.16-.21.32-.33.47.12-.15.23-.3.33-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m11.03,53.47l.03.02h.01s-.03-.01-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m9,51.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m9.77,52.59h0l.02.02s-.03-.03-.05-.04l.03.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "15 51.01 14.99 51.01 15.03 51.02 15 51.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m23.21,33.04l-1.23-.59.04.02h0c.05.02.1.05.15.08.05.03.1.05.15.08.03.02.06.03.09.05.11.06.23.12.34.19h.02c.1.07.21.14.31.2.03.02.06.04.09.05.03.02.07.04.1.07.07.04.14.09.2.13h.02c.11.08.21.16.31.23.03.02.05.04.08.06.09.07.18.14.27.21l.04.03c.1.08.2.16.29.24.02.02.05.04.07.06.04.04.08.07.12.11.04.04.08.07.12.11l.02.02.04.03c.09.09.18.17.27.26.02.02.04.04.06.06.07.07.15.15.22.23.02.02.04.04.06.06.09.09.17.19.25.28.02.02.04.04.05.06.06.07.11.14.17.2l.03.04h0s.04.05.05.07c.04.05.07.09.11.14.04.05.08.11.12.16.01.02.03.04.04.06.07.09.13.18.19.27.02.03.04.05.06.08.07.11.14.21.21.32l.03.04.03.04c.05.08.1.17.16.25.02.03.03.06.05.09.07.11.13.22.19.34h0c.04.09.08.16.12.24.02.04.04.07.06.11.02.03.03.06.05.09.05.11.11.22.16.33v.03c.07.12.12.24.17.36.01.03.03.06.04.09.04.11.09.21.13.32,0,.02.01.04.02.06.05.12.09.25.13.37.01.03.02.06.03.09.03.11.07.21.1.32v.04s.02.04.02.04h0c.04.13.07.26.1.38,0,.03.01.06.02.09.03.11.05.22.08.33,0,.03.01.06.02.09.03.13.05.26.08.4,0,.03,0,.06.01.08.02.11.04.22.05.34,0,.03,0,.07.01.1v.04c.02.12.04.24.05.36,0,.02,0,.05,0,.07,0,.04,0,.08,0,.12,0,.08.01.16.02.24,0,.04,0,.07,0,.11,0,.14.02.28.02.42v.04c0,.13,0,.26,0,.38,0,.04,0,.07,0,.11,0,.14,0,.29,0,.43-.2,4.97-3.12,9.28-7.21,11.4h-.03c-.09.06-.18.1-.27.15h-.01c-1.03.5-2.14.87-3.29,1.06h-.04c-.12.03-.24.05-.36.06h-.03c-.13.02-.26.04-.4.05h-.01c-.12.01-.24.02-.36.03-.03,0-.07,0-.1,0-.09,0-.19.01-.28.01-.04,0-.07,0-.11,0-.13,0-.25,0-.38,0-.11,0-.22,0-.33,0-.04,0-.07,0-.11,0-.07,0-.15,0-.22,0-.04,0-.09,0-.13,0-.07,0-.13,0-.2-.01-.05,0-.09,0-.14-.01-.06,0-.12-.01-.19-.02-.02,0-.05,0-.07,0-.02,0-.05,0-.07,0-.06,0-.12-.01-.18-.02-.05,0-.09-.01-.14-.02-.06,0-.12-.02-.18-.03-.05,0-.09-.02-.14-.02-.06-.01-.12-.02-.17-.03-.05,0-.09-.02-.14-.03-.03,0-.06-.01-.09-.02-.03,0-.06-.01-.09-.02-.02,0-.03,0-.05-.01-.03,0-.06-.01-.09-.02-.06-.01-.11-.03-.17-.04-.05-.01-.09-.02-.14-.03-.06-.02-.11-.03-.17-.05-.04-.01-.09-.02-.13-.04-.03,0-.06-.02-.09-.03-.03,0-.05-.02-.08-.02-.04-.01-.09-.03-.13-.04h-.03s-.09-.04-.14-.06c-.04-.01-.08-.03-.12-.04-.06-.02-.12-.04-.18-.07-.04-.01-.07-.03-.11-.04-.07-.03-.14-.06-.22-.09-.02,0-.05-.02-.07-.03-.1-.04-.19-.08-.28-.12-.02-.01-.05-.02-.07-.03-.03-.02-.07-.03-.1-.05-.03-.02-.07-.03-.1-.05h-.01s1.23.58,1.23.58c1.53.73,3.24,1.14,5.06,1.14,6.82,0,12.58-5.72,12.87-12.78.21-5.17-2.57-9.63-6.76-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m7.92,48.83c-.23-.64-.41-1.31-.52-2,0-.04-.01-.07-.02-.11-.05-.32-.08-.64-.1-.96-.03-.01-.06-.03-.09-.04.03.02.06.03.09.04-.02-.36-.02-.72,0-1.09.24-5.91,5.07-10.7,10.77-10.7,1.28,0,2.5.24,3.62.68-.08-.05-.16-.09-.25-.14-.02-.01-.05-.03-.07-.04-.08-.04-.17-.09-.25-.13l-.04-.02h0c-.05-.02-.1-.05-.15-.07-.03-.01-.05-.03-.08-.04-.04-.02-.09-.04-.13-.06h-.02s-.06-.03-.09-.05h-.04c-.07-.04-.14-.07-.2-.1-.03-.01-.06-.02-.09-.03-.05-.02-.1-.04-.15-.06-.03-.01-.07-.02-.1-.04-.05-.02-.1-.03-.14-.05-.04-.01-.07-.02-.11-.03h0s-.09-.03-.14-.04h0s-.08-.02-.11-.03c-.05-.01-.09-.03-.14-.04-.04-.01-.08-.02-.12-.03-.05-.01-.09-.02-.14-.03-.04,0-.08-.02-.12-.03h-.02s-.01,0-.01,0c-.04,0-.07-.02-.11-.02-.04,0-.08-.02-.12-.02-.05,0-.09-.02-.14-.03h0s-.08-.01-.12-.02c-.05,0-.1-.02-.14-.02-.04,0-.08-.01-.12-.02-.03,0-.06,0-.09-.01-.02,0-.04,0-.06,0-.04,0-.08,0-.12-.01-.05,0-.1-.01-.15-.01h0s-.08,0-.12-.01h-.01s0,0,0,0c-.04,0-.07,0-.11,0h-.03s0,0,0,0c-.04,0-.08,0-.11,0-.06,0-.11,0-.17,0-.03,0-.07,0-.1,0-.04,0-.08,0-.13,0-.04,0-.08,0-.12,0h-.03c-.23,0-.46,0-.7.02-.52.04-1.04.11-1.54.23h0c-.25.06-.5.12-.74.2h0c-.24.08-.49.16-.72.25h0c-.24.09-.47.19-.7.3h0c-.23.11-.46.23-.68.35h0c-.22.13-.44.26-.65.4h0c-.21.14-.42.29-.62.44-2.39,1.83-4.04,4.65-4.36,7.85-.01.1-.02.21-.03.31v.02c0,.11-.02.21-.02.32h0c0,.09,0,.18,0,.28,0,.03,0,.06,0,.09,0,.06,0,.12,0,.19,0,.03,0,.06,0,.08h0s0,.03,0,.03c0,.03,0,.05,0,.08,0,.03,0,.05,0,.08v.03s0,.01,0,.01c0,.02,0,.04,0,.06h0s0,.06,0,.08c0,.07,0,.14.01.21h0s0,.03,0,.05c0,.03,0,.05,0,.08,0,.03,0,.05,0,.08h0s0,0,0,0h0s0,.04,0,.04h0s0,.05,0,.05h0s0,.05,0,.08c0,.03,0,.07.01.1,0,.05.01.1.02.15,0,.04,0,.07.01.11,0,.03,0,.06.01.09,0,.03,0,.06.01.1.02.11.04.22.06.33,0,.02,0,.04.01.07.01.07.03.13.04.2,0,.03.02.07.02.1.01.05.03.11.04.16h0s0,.02,0,.02v.03c.03.09.06.19.08.28h0s.01.05.02.07c.03.09.05.19.08.28h0s.01.03.02.05h0s0,.02,0,.02v.02c.03.06.04.11.06.17.01.03.02.06.03.09h0s0,.01,0,.01c.01.03.02.07.04.1,0,.02.01.04.02.05,0,.02.02.05.03.07,0,.02.01.04.02.05,0,.02.01.03.02.05.01.03.02.05.03.08,0,.02.01.03.02.05,0,.02.01.04.02.05.02.04.03.08.05.11h0s.03.07.04.1c.02.05.04.1.07.15,0,.02.02.04.03.06v.02c.06.12.12.24.18.35h0s0,.01,0,.01v.02s.03.03.04.05v.02s.05.07.07.11c0,.02.02.04.03.05h0s.02.05.03.07h0s.01.02.01.02v.02s.03.03.03.03c.02.04.04.08.07.12v.02s.03.04.05.06l.02.03v.02s.06.08.09.12h0s.03.05.04.07h0s.02.03.02.03h0c.04.07.07.12.11.18l.02.03h0s.03.05.04.07h0s0,0,0,0c.03.05.07.1.1.15.08.11.16.22.25.32.02.03.05.06.07.09.05.06.09.11.14.17.02.03.05.06.07.09.05.06.11.12.16.18.02.02.04.04.06.06.07.08.15.16.22.23h0c.08.09.17.17.25.25h0s.02.02.02.02l.04.04h0s.08.08.13.12h0s.04.03.04.03c.02.02.03.03.05.04h0s.08.07.13.11l.03.03s.04.03.06.05h0s.03.03.05.04c.08.07.17.14.26.2l.04.03c.1.07.19.14.29.21h0c.1.08.21.15.31.21h.02c.1.07.19.13.29.19.02.01.03.02.05.03.1.06.2.11.3.17h.01s.01.01.01.01c.22.12.45.22.68.32h.03c.07.04.15.07.22.1-2.02-1.15-3.58-3.02-4.41-5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m17.76,36.99c.08.02.17.05.25.08l.05-1.18-.25-.12-.05,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m17.16,45.23l-.04-.02s-.03-.01-.05-.02l-.04-.02s-.03-.01-.05-.02h-.04s-.04-.02-.05-.03h-.04s-.04-.02-.06-.02h-.04s-.04-.01-.06-.02h-.04s-.04,0-.07-.01h-.04s-.07,0-.1,0h0c-.06,0-.12,0-.18,0h-.03s-.03,0-.03,0c-.04,0-.08,0-.13-.01-.02,0-.03,0-.05,0h-.02c-.05,0-.1-.01-.15-.02h-.03s-.04-.01-.05-.02c-.03,0-.06-.01-.08-.02-.02,0-.04,0-.06-.01h-.04s-.04-.02-.07-.03c-.03,0-.06-.02-.09-.02-.03,0-.05-.01-.08-.02h-.04s-.05-.03-.07-.04c-.03,0-.06-.02-.08-.03-.03-.01-.06-.02-.09-.04h0s-.05-.03-.08-.04c-.03-.01-.07-.03-.1-.04l-.04-.02.25.12c.49.24,1.04.37,1.63.37.24,0,.47.05.67.13-.05-.03-.1-.05-.14-.07-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m14.41,47.27s0,.08,0,.12h0c0,.06.01.1.02.14v.03s.02.07.03.11v.02s.03.08.04.12v.03s.03.07.05.1v.02s.04.07.06.11v.02s.04.06.06.09v.02s.06.07.08.1v.02s.05.05.08.08l.02.02s.05.06.08.09h.01s.05.06.07.09l.02.02s.06.05.09.08h0s.06.05.09.07l.03.02s.07.04.1.06h0s.07.04.11.06c.04.02.09.04.14.06-.59-.34-.98-1.01-.94-1.77l-.25-.12s0,.09,0,.13v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m15.19,51.07s-.1-.03-.15-.04h-.01s-.04-.02-.04-.02c-.03-.01-.06-.02-.09-.03h-.03s-.04-.02-.04-.02c-.03-.01-.05-.02-.08-.03l-.04-.02h-.03s-.05-.03-.07-.05c-.02,0-.03-.01-.05-.02h-.01s.25.11.25.11c.13.06.26.11.39.16v-.04s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m18.65,37.36l.03.02s.07.04.1.06c.02,0,.03.02.05.03.03.02.05.04.08.05.02.01.03.02.05.03.03.02.05.04.07.05.02.01.03.02.05.04.02.02.05.04.07.06l.04.04s.05.04.08.07l.04.03s.05.04.07.06h0s.03.03.03.03h0s.04.05.06.07h0s.04.05.04.05l.03.03.02.02h0s.03.04.05.06l.04.04h0s0,.01,0,.01c.02.02.03.04.05.06l.03.04h0s.04.05.05.08c.01.02.02.03.04.05.02.03.04.05.05.08.01.02.02.03.03.05.02.03.04.06.06.09v.02s.03.02.03.02c.02.03.03.05.05.08v.02s.03.03.03.03v.02s.03.03.04.05v.03s.03.04.03.04c0,.02.02.03.02.05h0s.02.05.02.05c0,.02.01.03.02.05,0,.02.02.04.02.05v.03s.03.04.04.06c0,.02.01.04.02.05v.03s.03.05.04.07c0,.02.01.03.02.05v.02s.02.06.03.09c0,.02,0,.03.01.05h0s.02.07.03.1c0,.02,0,.03.01.05h0s.01.07.02.1c0,.02,0,.03.01.05v.02s.01.04.01.04v.03s.01.04.02.05v.03s.01.04.01.06h0s0,.04,0,.06v.04s.01.04.01.06c0,.02,0,.03,0,.05,0,.02,0,.04,0,.05,0,.02,0,.04,0,.06v.04s0,.05,0,.07c0,.02,0,.04,0,.06v.02s0,.06,0,.09c0,.02,0,.04,0,.05h0c0,.06,0,.12,0,.17h-2.04l.25.12h2.04c.07-1.66-.83-3.09-2.18-3.74l-.25-.12s.06.03.09.04l.03.02s.09.05.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.24,49.78s-.04-.05-.06-.08c.02.03.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.33,49.9s-.04-.05-.07-.08c.02.03.04.05.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.15,49.67s-.04-.06-.06-.08c.02.03.04.06.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.5,50.08c-.05-.05-.11-.11-.16-.17.05.06.1.11.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.69,50.26s-.04-.04-.06-.05c.02.02.04.04.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.07,49.55s-.04-.06-.06-.09c.02.03.04.06.06.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.59,50.16s-.04-.04-.06-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.94,48.99c.09-.03.18-.07.26-.12-.08.05-.17.09-.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.2,48.87c.06-.03.11-.06.16-.1-.05.04-.11.07-.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.14,46.22c-.02-.06-.05-.12-.08-.17.03.06.06.11.08.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.22,39.09s.02.05.03.08c0-.02-.02-.04-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.57,48.55c-.07-.23-.13-.46-.16-.7.03.24.09.48.16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.67,48.82s-.03-.08-.05-.12c.01.04.03.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.62,48.69s-.03-.08-.04-.12c.01.04.03.08.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.99,49.44c-.12-.19-.22-.39-.31-.6.09.21.19.41.31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.37,47.1c-.01.26,0,.51.04.75l.42-.75h-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.14,44.86s-.07-.02-.1-.04c.03.01.06.02.09.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.43,48.91c.06.03.11.05.17.08h0s-.09-.04-.14-.06h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.78,44.7s-.08-.04-.12-.06c.04.02.08.04.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.03,44.81c-.08-.03-.16-.07-.23-.1.02,0,.04.02.05.03.03.02.07.03.1.04.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.4,39.55s.01.04.02.06c0-.02,0-.03-.01-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.28,39.24s.02.05.03.07c0-.02-.01-.04-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.55,40.23s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.34,39.39s.02.05.03.07c0-.02-.01-.03-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.57,40.39s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "20.58 40.96 20.58 40.96 18.55 40.96 18.55 40.96 18.55 40.96 20.58 40.96 20.58 40.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.58,40.56s0,.04,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.52,37.29l-.03-.02h-.03s.08.03.12.05c-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.29,43.42s-.03-.02-.05-.03l-.03-.02s.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.69,38.24s.05.06.07.09l-.03-.04-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.55,40.79v.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.78,44.86s-.02-.03-.03-.05l-.03-.04-.03-.04s.05.09.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.61,43.61l-.03-.02-.04-.03h-.02s.06.03.09.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "14.66 41.09 14.66 41.12 14.66 41.1 14.66 41.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.02,39.07h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.2,39.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.93,39.1h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.11,39.04h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.45,43.51s-.04-.02-.06-.04h0s-.02-.01-.02-.01c.03.02.06.03.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.71,41.52v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.27,46.17s0-.05-.01-.08v-.04c-.02-.06-.03-.12-.05-.17v-.04s-.04-.09-.05-.13c0-.02-.01-.03-.02-.05-.02-.05-.03-.1-.05-.14v-.03c-.03-.05-.05-.11-.07-.16l-.02-.04s-.04-.08-.06-.12c0-.02-.01-.03-.02-.05-.03-.05-.05-.1-.08-.15h0s-.03-.06-.05-.09c.23.39.39.83.48,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.85,39.14h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.74,41.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.95,39.98l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.47,42.65h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.9,40.06l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.84,41.89v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.76,39.19l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15,39.9l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.69,44.71s-.02-.03-.03-.05l-.03-.04-.03-.04s.06.08.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.05,39.82l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.59,44.57s-.04-.06-.06-.09l-.02-.02v-.02s.05.08.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.9,43.82h-.02s-.02-.03-.02-.03c-.02-.01-.03-.03-.05-.04.03.02.06.05.09.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.04,43.94h0s-.04-.04-.04-.04c-.02-.01-.03-.03-.05-.04.03.03.06.05.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.5,44.44s-.05-.06-.07-.09l-.03-.04s-.06-.07-.09-.1l-.03-.03s-.08-.08-.12-.12l-.03-.03s-.04-.04-.07-.06c.16.14.3.3.43.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.11,39.74l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.6,39.29l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.52,39.34l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.17,39.66l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.68,39.23l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.45,39.4l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.37,39.46l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.24,39.59l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.3,39.52l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.82,43.21s.05.02.07.03c-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.14,39.66h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.22,39.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.93,39.44h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.3,39.91h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.82,40.24s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.78,40.33s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.75,40.43s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.88,42.86h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.37,40.05v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.48,40.34v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.15,43.16c-.04-.07-.08-.14-.11-.21.04.07.07.14.11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.29,43.38c-.04-.06-.08-.13-.12-.19.04.07.08.13.12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m12.92,42.68c-.03-.07-.05-.13-.07-.2.02.07.05.13.07.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.03,42.94c-.04-.07-.07-.15-.1-.23.03.08.07.15.1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.51,40.5v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.73,40.52s0-.04.01-.05c0,.02,0,.04-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.54,40.65v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.9,43s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.01,43.28s.07.03.1.05c-.03-.02-.07-.03-.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.64,43.15s.05.02.08.02c-.02,0-.05-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.86,40.15l.02-.05s-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.76,43.71l-.03-.02-.04-.03h-.02s.06.03.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.67,40.83s0-.04,0-.07c0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.67,41.25v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.6,43.79c-.11-.12-.21-.25-.3-.39.09.14.19.27.3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.66,40.96s0-.06,0-.1c0,.03,0,.06,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.68,40.72s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.18,42.94h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.34,42.97h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.7,40.62s0-.04.01-.06c0,.02,0,.04-.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.71,42.98s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.09,43.02s.05,0,.08.01c-.03,0-.05,0-.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.28,43.05s.05.01.08.02c-.03,0-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.46,43.09s.05.01.08.02c-.03,0-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.68,41.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.34,51.02s.09-.03.14-.05c-.05.02-.09.03-.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.17,50.62s-.03-.02-.05-.03c.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.04,50.53s-.04-.03-.06-.04c.02.01.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.48,50.79s-.04-.02-.05-.03c.02,0,.04.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.81,50.36s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m13.92,50.45s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.49,50.97c.1-.04.2-.08.3-.12-.1.04-.2.08-.3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.33,50.72l-.04-.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.75,42.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.67,45.01s-.05,0-.07-.02h0s.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.29,44.91s-.06-.02-.09-.03h.02s.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.5,44.97s-.08-.02-.12-.03h.03s.06.02.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.06,45.06s-.03,0-.05,0h0s.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.84,45.04s-.04,0-.06,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.25,45.08s-.04,0-.05,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.46,47.67s-.02-.07-.02-.11v-.03s-.01-.02-.01-.02c.01.07.02.13.04.19h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.5,47.81s-.02-.07-.03-.11c.02.06.04.12.06.18v-.04s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.01,48.61l-.03-.03s.09.08.14.12c-.03-.02-.06-.05-.09-.08l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.22,48.78s-.06-.04-.09-.07h0s0,0,0,0c.05.04.1.07.15.11l-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.92,48.52s-.05-.06-.08-.09l-.02-.02-.03-.03c.06.07.12.14.18.21-.02-.02-.03-.03-.05-.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.67,48.18s-.03-.06-.05-.09v-.02s-.05-.07-.06-.11v-.02s-.02-.04-.03-.05c.04.12.1.23.17.34h0s-.01-.04-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.9,50.98s-.04-.01-.06-.02h.03s.03.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.76,50.92s-.04-.02-.06-.02h.02s.04.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.04,51.03s-.03-.01-.05-.02h.03s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.56,50.83h0s.03.02.05.03c-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.27,37.81s-.05-.04-.08-.07l-.04-.04s-.05-.04-.07-.06c-.02-.01-.03-.02-.05-.04-.02-.02-.05-.04-.07-.05-.02-.01-.03-.02-.05-.03-.03-.02-.05-.04-.08-.05-.02,0-.03-.02-.05-.03-.02-.01-.05-.03-.07-.04.24.14.46.31.66.5-.02-.02-.04-.04-.06-.06l-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.49,39.92h0s0,.03.01.06h0s0-.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.41,37.94l-.03-.02s.06.05.08.08c-.02-.02-.03-.03-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.09,38.84v-.02s.02.05.03.08l-.02-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.52,38.05l-.03-.04s.05.05.08.08h-.01s-.03-.05-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.91,38.53s-.04-.05-.05-.08c-.01-.02-.02-.03-.04-.05-.01-.02-.03-.04-.04-.06.08.1.15.21.22.31-.02-.03-.03-.05-.05-.08-.01-.02-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.65,37.36s-.04-.02-.06-.03c.04.02.08.04.11.07h-.02s-.03-.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.52,40.08h0s0,.04.01.06h0s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.58,40.74h0s0,.03,0,.05c0-.02,0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m19.63,38.17l-.03-.04s.05.06.07.08h0s-.04-.04-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.46,39.75s0,.04.01.06c0-.02,0-.03-.01-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20,38.68s.03.06.05.08c-.01-.02-.02-.04-.03-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.16,38.98v-.02s.01.05.03.08h0s-.02-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "17.14 52.25 17.14 52.02 16.99 52.29 15.14 52.29 15.14 52.29 17.13 52.29 17.14 52.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m7.23,49.45c-.06-.12-.12-.24-.17-.35h0s-.02-.05-.02-.05h0s-.01-.03-.01-.03c-.02-.05-.05-.1-.07-.15v-.03s-.02-.01-.02-.01c0-.02-.02-.04-.03-.06h0s-.03-.08-.05-.12v-.02s-.02-.03-.02-.03c0-.02-.02-.04-.03-.06,0-.02-.01-.03-.02-.05,0-.02-.02-.04-.02-.06,0-.02-.02-.04-.02-.06h0s-.02-.05-.03-.07v-.02s-.02-.04-.03-.06c-.01-.03-.02-.06-.03-.09-.01-.03-.02-.06-.03-.09v-.04c-.04-.07-.06-.15-.09-.22h0c-.03-.09-.06-.19-.08-.28,0-.02-.01-.05-.02-.07h0c-.03-.09-.05-.19-.07-.28v-.03s-.01-.02-.01-.02c-.01-.05-.03-.11-.04-.16,0-.03-.02-.07-.02-.1-.01-.07-.03-.13-.04-.2,0-.02,0-.04-.01-.07-.02-.11-.04-.22-.06-.33,0-.03,0-.06-.01-.1,0-.03,0-.06-.01-.09,0-.04,0-.07-.01-.11,0-.05-.01-.1-.02-.15,0-.03,0-.07-.01-.1,0-.02,0-.05,0-.07v-.04s0-.01,0-.01v-.04s0,0,0,0h0s0-.06,0-.09c0-.03,0-.05,0-.08,0-.02,0-.03,0-.05h0c0-.07,0-.14-.01-.21,0-.02,0-.05,0-.07h0s0-.06,0-.08v-.03s0-.05,0-.08c0-.03,0-.05,0-.08v-.03s0-.06,0-.08c0-.06,0-.12,0-.19,0-.03,0-.06,0-.09,0-.09,0-.18,0-.28h0c0-.11.01-.21.02-.32v-.02c0-.1.02-.21.03-.31h0s-1.89,3.39-1.89,3.39h0c.01.09.03.17.05.26,0,.04.02.08.02.12.02.08.03.17.05.25,0,.03.01.05.02.08.04.16.08.33.12.49,0,.04.02.07.03.11.02.08.05.16.07.24.01.04.02.07.03.11.05.17.11.34.17.51v.02c.04.08.07.16.1.24.01.04.03.07.04.11.03.08.06.16.1.24l.02.04c.07.16.14.32.21.47.02.03.03.06.05.09.04.08.07.15.11.23.02.03.03.06.05.09.08.16.17.31.25.46l.02.03c.04.07.09.15.13.22.02.03.04.06.06.09.05.07.09.14.14.22h0s1.17-2.1,1.17-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m14.85,32.1c-1.1.3-2.16.71-3.14,1.25l-1.24,2.24h0c.2-.16.41-.3.62-.44h0c.21-.14.43-.27.65-.4h0c.22-.13.45-.24.68-.35h0c.23-.11.46-.21.7-.3h0c.24-.09.48-.18.72-.25h0c.24-.08.49-.14.74-.2h0c.5-.11,1.02-.19,1.54-.23h0l1.17-2.1c-.13,0-.26,0-.39,0-.1,0-.21,0-.31,0-.03,0-.07,0-.1,0-.07,0-.14,0-.2,0-.04,0-.08,0-.12,0-.06,0-.12,0-.18.01-.04,0-.09,0-.13.01-.06,0-.12.01-.18.02-.04,0-.09,0-.13.01-.06,0-.11.01-.17.02-.05,0-.09.01-.14.02-.06,0-.11.02-.17.02-.05,0-.09.01-.14.02-.05,0-.11.02-.16.03-.05,0-.09.02-.14.02-.05.01-.11.02-.16.03-.04,0-.09.02-.13.03-.05.01-.11.02-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.04-.05.02-.11.03-.16.05-.04.01-.08.03-.12.04-.06.02-.11.04-.17.06-.04.01-.08.03-.12.04-.06.02-.12.04-.18.07-.03.01-.07.02-.1.04-.08.03-.16.06-.25.1h-.03s-.35.64-.35.64c.91-.37,1.87-.62,2.84-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m9.25,52.14h0c-.08-.08-.17-.16-.25-.24h0c-.08-.08-.15-.16-.22-.24h0s0,0,0,0l-.04-.04h0s-.01-.01-.01-.01c-.05-.06-.11-.12-.16-.18h0s0,0,0,0c-.02-.02-.04-.04-.05-.06h0l-.02-.02c-.05-.06-.09-.11-.14-.17-.02-.02-.03-.04-.05-.06h-.01s-.01-.03-.01-.03c-.08-.11-.17-.21-.25-.32h0s-1.1,1.97-1.1,1.97c.1.12.2.23.3.35h0c.1.11.2.22.31.33h0c.1.12.21.22.32.32h.01c.11.12.22.22.34.32l1.04-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m17.64,33.42h0s.02,0,.02,0h.02s.06,0,.1.01h0c.05,0,.1,0,.15.02h0s.04,0,.06,0c.02,0,.04,0,.06,0h0s.04,0,.06,0c.03,0,.06,0,.09.01.04,0,.08.01.12.02h0s.1.01.14.02h0s.08.01.12.02c.05,0,.1.02.14.03.04,0,.08.02.12.02.04,0,.08.02.12.03h.02s0,0,0,0c.04,0,.08.02.12.03.05.01.1.02.14.03.04,0,.08.02.11.03.04.01.08.02.12.03l1.05-1.88h0c-.13-.04-.26-.08-.4-.12-.03,0-.06-.02-.08-.02-.13-.04-.26-.07-.39-.1h0c-.3-.07-.6-.13-.9-.18h0l-1.1,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m26.64,45.09h0c-.05.41-.13.82-.23,1.22h0s0,.01,0,.01h0c-.03.13-.07.26-.1.38h0s0,0,0,0h0c-.04.13-.07.25-.11.37v.04c-.05.12-.09.23-.13.35h0s0,.01,0,.01h0c-.04.12-.09.23-.13.35h0s-.02.04-.03.06c-.05.11-.09.23-.14.34l2.98-5.37c0-.06,0-.12,0-.17,0-.04,0-.07,0-.11,0-.08-.01-.16-.02-.24,0-.04,0-.08,0-.12,0-.02,0-.05,0-.07-.01-.12-.03-.24-.04-.36v-.04s-.01-.07-.02-.1c0-.03-.01-.06-.02-.09l-1.96,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m24.81,49.94h0c-.15.23-.32.45-.48.67h0s0,0,0,0h0c-.25.32-.52.63-.81.92h0s-.02.02-.02.02h0c-.18.19-.37.37-.57.54l-.03.02h0c-.1.09-.2.17-.3.25l-1.96,3.53c.2-.08.39-.17.59-.27h.01c.09-.05.18-.09.27-.14h.03c.1-.06.19-.11.28-.17l3-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m8.42,35.17c.44-.42.91-.81,1.41-1.16l.03-.02.4-.71h0c-.25.16-.5.33-.75.51h0c-.24.18-.48.37-.71.56h0s-.55.98-.55.98c.06-.06.11-.11.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m9.26,35.06c-.17.15-.34.31-.51.47-.63.61-1.2,1.27-1.71,1.99l-1.6,2.87c-.15.35-.29.71-.42,1.07.03-.17.06-.33.1-.5l-.94,1.69h0c-.02.12-.03.23-.05.35h0c-.01.12-.03.23-.04.34v.04c-.01.1-.02.2-.03.3,0,.02,0,.04,0,.06,0,.12-.01.24-.02.35h0c0,.12,0,.24,0,.36h0s5.22-9.4,5.22-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m10.92,55.78s.07.03.1.05c.02.01.05.02.07.03.09.04.19.08.28.12.02,0,.05.02.07.03.07.03.14.06.22.09.04.01.07.03.11.04.06.02.12.05.18.07.04.01.08.03.12.04.05.02.09.03.14.05h.03s.09.04.13.05c.03,0,.05.02.08.02.03,0,.06.02.09.03.04.01.09.03.13.04.06.02.11.03.17.05.05.01.09.02.14.03.06.01.11.03.17.04.03,0,.06.01.09.02.02,0,.03,0,.05.01.03,0,.06.01.09.02.03,0,.06.01.09.02.05,0,.09.02.14.03.06.01.12.02.17.03.05,0,.09.02.14.02.06,0,.12.02.18.03.05,0,.09.01.14.02.06,0,.12.02.18.02.02,0,.05,0,.07,0l1.12-2.01c-.13,0-.26-.01-.39-.02h-.03s0,0,0,0c-.26-.02-.52-.05-.78-.09h-.04c-.26-.05-.51-.1-.76-.16h-.03s0,0,0,0c-.12-.03-.24-.06-.37-.1h0s0,0,0,0c-.13-.04-.25-.08-.37-.12h0s-.01,0-.01,0h0c-.12-.04-.23-.08-.35-.12h0s-.03,0-.03,0c-.04-.01-.08-.03-.12-.05-.07-.03-.15-.06-.22-.09h-.03c-.23-.11-.46-.22-.68-.34h-.03c-.1-.07-.2-.12-.3-.18h-.01s0,0,0,0l-.03-.02h0s0,0,0,0c-.1-.06-.19-.12-.29-.18h-.02c-.11-.08-.21-.15-.31-.22h0c-.1-.07-.2-.14-.29-.22h0s0,0,0,0h-.01s-.02-.03-.02-.03c-.09-.07-.17-.13-.26-.2l-.02-.02-1.03,1.86c.23.18.46.34.7.5.03.02.07.04.1.07.06.04.13.08.19.12.09.06.19.11.28.17.04.02.08.05.12.07.08.04.15.08.23.13.04.02.07.04.11.06.11.06.23.12.34.17h0s.07.03.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m20.13,33.95s.09.03.14.05c.03.01.06.02.08.03.07.03.15.06.22.09h.02s0,0,0,0c.03.01.06.03.09.04.05.02.1.04.15.06.03.01.05.02.07.03h0c.05.03.1.05.15.07h0s.02,0,.02,0h.02s0,.01,0,.01c.08.04.17.08.25.13h0s.05.03.07.04h0c.08.04.16.09.25.14l.04.02h0s0,0,0,0h0c.07.04.15.09.22.13l.04.02s.05.03.07.04h0s.09.06.13.09c.04.03.08.05.13.08h.01c.09.07.18.13.26.19.02.01.03.02.05.03h.02s0,.01,0,.01h0c.08.06.15.11.22.17h0s.03.03.03.03c.08.07.17.13.25.2.02.02.04.03.06.05.07.06.14.12.2.18l.04.04s.08.08.13.12c.03.03.07.07.1.1h0s.04.04.05.05c.06.06.13.13.19.19.02.02.03.03.05.05l.02.02c.07.07.13.14.19.21h0s.03.03.04.05c.02.03.05.06.07.08.03.04.07.08.1.12h0s.02.03.02.03l.03.03c.05.06.09.12.14.17.02.03.04.05.06.08l.03.05c.05.06.09.12.13.19l.03.04h0s.03.04.05.07c.04.06.09.13.13.19l1.12-2.01s-.07-.09-.11-.14c-.02-.02-.04-.04-.05-.07h0s-.03-.05-.03-.05c-.06-.07-.11-.14-.17-.2-.02-.02-.04-.04-.05-.06-.08-.1-.17-.19-.25-.28-.02-.02-.04-.04-.06-.06-.07-.08-.15-.15-.22-.23-.02-.02-.04-.04-.06-.06-.09-.09-.18-.18-.27-.26l-.04-.03-.02-.02s-.08-.07-.12-.11c-.04-.04-.08-.07-.12-.11-.02-.02-.05-.04-.07-.06-.1-.08-.19-.16-.29-.24l-.04-.03c-.09-.07-.18-.14-.27-.21-.03-.02-.05-.04-.08-.06-.1-.08-.21-.15-.31-.22h-.02c-.07-.06-.14-.1-.2-.15-.03-.02-.07-.04-.1-.07-.03-.02-.06-.04-.09-.05-.1-.06-.21-.13-.31-.19h-.02c-.11-.08-.22-.14-.34-.2-.03-.02-.06-.03-.09-.05-.05-.03-.1-.05-.15-.08-.05-.03-.1-.05-.15-.08h0c-.13-.06-.25-.12-.38-.18-.03-.01-.06-.02-.08-.04-.13-.06-.26-.11-.39-.16l-1.03,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m25.65,38.9h0c.05.1.09.19.13.28v.02s.05.08.06.12c0,.02.01.03.02.05.01.02.02.05.03.07.01.02.02.05.03.08,0,.02.02.04.03.07.02.04.03.08.05.12v.04s.04.08.06.11l.02.04h0s0,0,0,0h0s0,.01,0,.01c.04.1.07.2.1.3,0,.03.02.06.03.08.03.08.05.16.08.24,0,.02.01.05.02.07.03.1.06.21.09.31,0,.02,0,.03.01.05.02.09.04.18.06.27,0,.03.01.05.02.08.02.1.04.2.06.3v.02c.02.11.04.22.06.33,0,.02,0,.04,0,.06.01.09.03.19.04.28,0,.02,0,.04,0,.06.01.11.02.23.03.35h0s1.55-2.79,1.55-2.79h0s-.01-.04-.01-.04v-.04c-.04-.11-.08-.21-.11-.32-.01-.03-.02-.06-.03-.09-.04-.13-.09-.25-.13-.37,0-.02-.01-.04-.02-.06-.04-.11-.08-.21-.13-.32-.01-.03-.03-.06-.04-.09-.05-.12-.1-.24-.16-.36v-.03c-.06-.11-.12-.22-.17-.33-.02-.03-.03-.06-.05-.09-.02-.04-.04-.07-.06-.11-.04-.08-.08-.15-.12-.23h0c-.06-.13-.13-.24-.19-.35-.02-.03-.03-.06-.05-.09-.05-.08-.1-.17-.16-.25l-1.18,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m20.64,53.65h0c-1.17.6-2.45.98-3.8,1.1l-1.18,2.12c.07,0,.14,0,.2,0,.13,0,.25,0,.38,0,.04,0,.07,0,.11,0,.09,0,.19,0,.28-.01.03,0,.07,0,.1,0,.12,0,.24-.02.36-.03h.01c.13-.01.26-.03.4-.05h.03c.12-.02.24-.04.36-.06h.04c.39-.08.78-.16,1.16-.27l1.55-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m12.01,32.81c-.21.09-.41.18-.62.28-.54.25-1.05.56-1.54.9l-.03.02c-.5.35-.97.74-1.41,1.16-.06.05-.11.11-.17.17-.8.8-1.49,1.72-2.03,2.72-.5.91-.87,1.89-1.09,2.9-.04.17-.07.33-.1.5.13-.36.27-.72.42-1.07.31-.74.68-1.45,1.1-2.13.16-.25.32-.5.49-.74.51-.71,1.08-1.38,1.71-1.99.16-.16.33-.32.51-.47.27-.23.54-.46.83-.67.47-.35.96-.67,1.47-.96.05-.03.1-.05.14-.08.98-.54,2.04-.95,3.14-1.25-.97.09-1.93.34-2.84.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 15.84,
    cy: 43.73,
    r: 8.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m22.56,41.17c0,.14-.27.26-.59.26h-5.08c-.32,0-.72,0-.87.02-.16.01-.42-.14-.25-.42l1.46-2.52c.16-.28.52-.38.81-.22l4.02,2.32c.28.16.51.41.51.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m16.53,37.42c.12.07.09.36-.07.64l-2.54,4.4c-.16.28-.29.51-.29.51,0,0-.06.11-.12.25-.07.14-.33.3-.49.02l-1.46-2.52c-.16-.28-.07-.64.22-.81l4.02-2.32c.28-.16.61-.24.74-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m10.27,40.78c.12-.07.36.1.52.38l2.54,4.4c.16.28.3.51.3.51,0,0,.07.11.16.23.09.13.09.43-.23.43h-2.92c-.32,0-.59-.27-.59-.59v-4.65c0-.32.1-.65.22-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m10.04,47.88c0-.14.27-.26.59-.26h5.08c.32,0,.59,0,.59,0h.29c.3-.06.41.12.25.4l-1.46,2.52c-.16.28-.52.38-.81.22l-4.02-2.32c-.28-.16-.51-.41-.51-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m16.08,51.62c-.12-.07-.09-.36.07-.64l2.54-4.4c.16-.28.29-.51.29-.51,0,0,.06-.11.12-.25.07-.14.33-.3.49-.02l1.46,2.52c.16.28.07.64-.22.81l-4.02,2.32c-.28.16-.61.24-.74.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m22.34,48.27c-.12.07-.36-.1-.52-.38l-2.54-4.4c-.16-.28-.3-.51-.3-.51,0,0-.07-.11-.16-.23-.09-.13-.09-.43.23-.43h2.92c.32,0,.59.27.59.59v4.65c0,.32-.1.65-.22.72Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m16.3,42.46c-1.22,0-2.21.99-2.21,2.21s.99,2.21,2.21,2.21h0c.34,0,.67-.08.96-.22-.49-.07-.87-.48-.87-.99,0-.55.45-1,1-1,.48,0,.87.33.97.78.09-.24.14-.5.14-.78,0-1.22-.99-2.21-2.21-2.21Zm-.84,2.1c-.27,0-.49-.22-.49-.49s.22-.49.49-.49.49.22.49.49-.22.49-.49.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 15.48,
    cy: 44.08,
    r: 0.57
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m49,6.41l-1.21-.58.04.02h0c-.12-.06-.25-.12-.38-.17-.03-.01-.05-.02-.08-.04-.08-.03-.16-.07-.24-.1,0,0-.02,0-.02,0-.04-.02-.08-.03-.12-.05h0c-.21-.08-.42-.16-.64-.23h0c-.13-.04-.26-.08-.39-.12-.03,0-.05-.02-.08-.02-.13-.03-.26-.07-.39-.1h0c-.29-.07-.59-.13-.89-.18h0c-.46-.07-.93-.12-1.41-.13-.13,0-.25,0-.38,0-.1,0-.2,0-.31,0-.03,0-.07,0-.1,0-.07,0-.13,0-.2,0-.04,0-.08,0-.12,0-.06,0-.12,0-.18.01-.04,0-.09,0-.13.01-.06,0-.12,0-.17.02-.04,0-.09,0-.13.01-.06,0-.11.01-.17.02-.04,0-.09.01-.13.02-.05,0-.11.02-.16.02-.04,0-.09.01-.13.02-.05,0-.11.02-.16.03-.04,0-.09.02-.13.02-.05.01-.11.02-.16.03-.04,0-.09.02-.13.03-.05.01-.11.02-.16.04-.04,0-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.08.02-.13.04-.05.02-.11.03-.16.05-.04.01-.08.02-.12.04-.06.02-.11.04-.16.05-.04.01-.08.03-.12.04-.06.02-.12.04-.18.06-.03.01-.07.02-.1.04-.08.03-.16.06-.24.09h-.03c-.73.3-1.42.66-2.08,1.08h0c-.25.16-.5.33-.74.51h0c-.24.18-.47.36-.7.56h0c-2.38,2.03-4.06,4.92-4.55,8.19h0c-.02.12-.03.23-.05.35h0c-.01.12-.03.23-.04.34v.04c-.01.1-.02.2-.03.3,0,.02,0,.04,0,.06,0,.12-.01.23-.02.35h0c0,.12,0,.24,0,.36-.01.8.05,1.59.18,2.35h0c.01.09.03.17.05.25,0,.04.02.08.02.12.02.08.03.17.05.25,0,.03.01.05.02.07.04.16.08.32.12.48,0,.04.02.07.03.11.02.08.05.16.07.24.01.04.02.07.03.11.05.17.11.34.17.51v.02c.04.08.07.16.1.24.01.04.03.07.04.11.03.08.06.16.1.23l.02.04c.07.16.14.31.21.46.01.03.03.06.04.09.04.07.07.15.11.22.02.03.03.06.05.09.08.15.16.3.25.45l.02.03c.04.07.09.14.13.22.02.03.04.06.06.09.04.07.09.14.14.21h0c.26.4.54.78.85,1.14h0s.03.03.04.04c.04.04.07.08.11.12.05.06.1.12.15.17h0c.1.11.2.22.31.33h0c.1.11.21.22.31.32h.01c.06.07.12.12.18.18,0,0,.01,0,.02.01.05.04.09.08.14.12h0c.17.15.35.29.52.43h0s.03.02.05.04c.03.02.05.04.08.06.04.03.07.05.11.08.03.02.05.04.08.06.04.03.07.05.11.08.03.02.05.04.08.06.06.04.13.09.19.13.03.02.07.04.1.06.06.04.12.08.19.12.09.06.18.11.28.17.04.02.08.05.12.07.07.04.15.08.23.12.04.02.07.04.11.06.11.06.22.11.34.17h0s-.01,0-.01,0l1.21.58c1.51.73,3.2,1.13,5,1.13,6.74,0,12.43-5.65,12.72-12.63.21-5.11-2.54-9.51-6.68-11.5Zm-2.12,1.29h.02s.02.02.02.02h0s-.04-.02-.04-.02h0Zm-.89-.37s.07.02.1.04c.03.01.06.02.08.03,0,0,0,0,0,0-.03-.01-.06-.02-.09-.03-.03-.01-.06-.02-.09-.03Zm.67.27s.04.02.06.03h0s-.04-.02-.07-.03Zm.51.25h0s.04.02.06.03c-.02-.01-.04-.02-.06-.03Zm-1.59-.65h0s.07.02.1.03c0,0,0,0,0,0-.04-.01-.07-.02-.11-.03Zm-.76-.2h0s.08.02.11.03c0,0,0,0,0,0-.04,0-.08-.02-.12-.03Zm-.78-.14s-.06,0-.08-.01c.03,0,.06,0,.09.01.04,0,.08.01.12.02h0s-.08-.01-.12-.02Zm-.41-.05s-.02,0-.02,0c0,0,.01,0,.02,0h0Zm.16.02s.03,0,.05,0c.01,0,.02,0,.03,0-.03,0-.05,0-.08,0Zm7.08,4.44l-.02-.03h0s.02.03.02.03h0Zm.16.27s.02.03.03.05h0s-.02-.04-.02-.04h0Zm.52.99v-.02s-.01,0-.01,0c0,0,0,0,0,0v.02s.05.08.06.12c-.02-.04-.03-.08-.05-.12Zm-.14-.3s.04.08.05.11c-.02-.04-.04-.08-.05-.11-.01-.03-.02-.05-.04-.08.01.02.02.05.03.07h0Zm-.79-1.32s.02.03.03.04c0-.01-.02-.03-.03-.04h0Zm-2.19-2.25s0,0,0,0h0s0,0,0,0Zm1.59,1.48s-.01-.01-.02-.02c0,0,.01.01.02.02h0Zm-.54-.58h0s0,0,.01.01c0,0,0,0-.01-.01Zm.95,1.09h0s0,0,0,0l.03.04c.04.06.09.12.13.18-.04-.06-.09-.12-.13-.18-.01-.02-.02-.03-.03-.05Zm-1.22-1.34s-.06-.05-.08-.07c.03.03.06.05.09.08l.02.02-.02-.02Zm-.23-.2s-.02-.02-.03-.03c-.08-.07-.16-.14-.24-.2l-.03-.02.03.02c.08.07.16.13.24.2.01,0,.02.02.03.03Zm-.86-.66h-.01s0,0,0,0h.01s0,.01,0,.01c0,0,0,0,0,0Zm-.59-.37h0s0,0,0,0h0Zm-1.58-.73s-.01,0-.02,0c-.02,0-.04-.01-.06-.02.02,0,.04.01.06.02,0,0,.02,0,.02,0h0Zm-2.71-.54s.07,0,.11,0h0s-.08,0-.11,0c-.06,0-.11,0-.17,0-.03,0-.07,0-.1,0-.04,0-.08,0-.12,0,.04,0,.08,0,.13,0,.03,0,.06,0,.09,0,.06,0,.12,0,.18,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.38,7.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.7,7.98h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.79,27.52h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.4,13.61l1.6-2.87c-.17.24-.34.49-.49.74-.42.68-.79,1.39-1.1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.04,17v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.56,6.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.17,27.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.08,7.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.81,7.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m36.05,26.07h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.02,26.72l-.03-.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m36.36,26.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.43,27.39h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m34.73,24.88l-.04-.04.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.73,21.66s-.02-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.9,22.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.81,21.87v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m34.51,24.64s-.04-.04-.05-.06c.02.02.04.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.99,22.28h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.05,8.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m48.89,25.32l-.03.02.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "52.05 13.16 52.04 13.15 52.04 13.15 52.05 13.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m50.28,23.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m49.47,24.76l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "50.4 10.25 50.38 10.22 50.38 10.22 50.38 10.23 50.4 10.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "48.84 8.71 48.88 8.74 48.84 8.71 48.84 8.71 48.84 8.71 48.84 8.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m50.21,10.02h0s.05.06.07.08c-.02-.03-.05-.06-.07-.08-.01-.02-.03-.03-.04-.05.01.02.03.03.04.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m51.88,21.08s-.02.04-.03.06c0-.02.02-.04.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m48.6,8.52s-.03-.02-.05-.03c-.09-.06-.17-.13-.26-.19.09.06.18.12.26.19.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m49.66,9.43h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m49.18,8.99c.07.06.14.12.2.18l.04.04h0s0,0,0,0c.04.04.08.07.12.11h0s-.08-.07-.13-.11l-.04-.04c-.07-.06-.13-.12-.2-.18-.02-.02-.04-.03-.06-.05-.08-.07-.16-.14-.25-.2.08.07.17.13.25.2.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.62,15.57s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.44,14.49s.01.05.02.08c0-.03-.01-.05-.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.52,14.87v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.25,13.78s.01.05.02.07c0-.02-.01-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.36,14.16s0,.03.01.05c0-.02,0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.57,15.22s0,.04,0,.06c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.15,13.46s.02.06.03.08c0-.03-.02-.06-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.02,20.72h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.27,19.94h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.15,20.32v.04s0-.04,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.37,19.55h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m51.81,12.56s-.03-.08-.05-.12v-.02s0,.02,0,.02c.02.04.04.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.03,16.91c0-.1.02-.2.03-.3,0,.1-.02.2-.03.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.44,5.03s.09-.02.13-.04c-.04.01-.09.02-.13.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.01,17.32c0-.12.01-.24.02-.35,0,.12-.01.24-.02.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.06,16.57c.01-.11.02-.22.04-.33-.01.11-.03.22-.04.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.23,20.32c-.02-.09-.03-.17-.05-.26.01.09.03.17.05.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.31,20.7c-.02-.08-.04-.17-.05-.25.02.08.03.17.05.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.1,16.23c.01-.12.03-.23.05-.35-.02.12-.03.23-.05.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.59,5.32s.07-.02.1-.04c-.03.01-.07.02-.1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.87,5.22s.08-.03.12-.04c-.04.01-.08.03-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.16,5.12s.08-.03.12-.04c-.04.01-.08.03-.12.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.31,5.42h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.46,7.02c.24-.18.49-.35.75-.51-.25.16-.5.33-.75.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.57,27.74h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.44,21.26c-.04-.16-.08-.32-.12-.49.04.16.08.33.12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m33.82,26.93c-.11-.1-.21-.2-.32-.31.1.11.21.21.32.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.7,28.38c-.06-.04-.13-.08-.19-.12.06.04.13.08.19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m33.49,26.61c-.1-.11-.21-.22-.31-.33.1.11.2.22.31.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.54,21.61c-.02-.08-.05-.16-.07-.24.02.08.05.16.07.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m36.44,28.8s-.07-.04-.11-.06c.04.02.07.04.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m36.1,28.61s-.08-.05-.12-.07c.04.02.08.05.12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.02,24.78c-.05-.07-.09-.14-.14-.22.05.07.09.14.14.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.99,22.84c-.03-.08-.06-.16-.1-.24.03.08.06.16.1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.68,24.22c-.09-.15-.17-.3-.25-.46.08.16.17.31.25.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.75,22.23c-.06-.17-.12-.34-.17-.51.05.17.11.34.17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.85,22.49c-.03-.08-.06-.16-.09-.24.03.08.06.16.09.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.38,23.67c-.04-.07-.08-.15-.11-.23.04.08.07.15.11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.22,23.35c-.07-.15-.14-.31-.21-.47.07.16.14.32.21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m34.75,7.59c.23-.2.47-.38.71-.56-.24.18-.48.37-.71.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.46,30c-.13.02-.26.03-.4.05.13-.01.26-.03.4-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.05,30.04c-.12.01-.24.02-.36.03.12,0,.24-.02.36-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.34,29.22s.05.02.07.03c.07.03.14.06.22.09-.07-.03-.14-.06-.22-.09-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m47.6,5.52c.13.06.26.12.38.18-.13-.06-.25-.12-.38-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.85,29.94c-.12.02-.24.04-.36.06.12-.02.24-.04.36-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m47.46,28.73c-.09.05-.18.09-.27.13.09-.04.18-.09.27-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.6,30.08c-.09,0-.19.01-.28.01.09,0,.19,0,.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.18,28h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.92,29.44s.08.03.12.04c.05.02.09.03.14.05-.05-.02-.09-.03-.14-.05-.04-.01-.08-.03-.12-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.36,27.9h-.04s.04,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.06,29.97c-.06,0-.12-.02-.18-.03-.05,0-.09-.02-.14-.02.05,0,.09.02.14.02.06,0,.12.02.18.03.05,0,.09.01.14.02.06,0,.12.02.18.02-.06,0-.12-.01-.18-.02-.05,0-.09-.01-.14-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.22,29.82s.03,0,.05.01c.03,0,.06.01.09.02-.03,0-.06-.01-.09-.02-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.52,29.63s-.06-.02-.09-.03c.03,0,.06.02.09.03.04.01.09.03.13.04.06.02.11.03.17.05-.06-.02-.11-.03-.17-.05-.04-.01-.09-.02-.13-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.88,4.54h0c.13,0,.26,0,.39,0-.13,0-.26,0-.39,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.61,4.75s.09-.02.14-.02c-.05,0-.09.02-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.91,4.7s.09-.01.14-.02c-.05,0-.09.01-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.08,4.98c.13.04.27.08.4.12-.13-.04-.26-.08-.4-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.21,4.65s.09-.01.14-.02c-.05,0-.09.01-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.02,4.88s.09-.02.13-.03c-.04.01-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.32,4.81s.09-.02.13-.03c-.04,0-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.52,4.61s.09-.01.13-.01c-.04,0-.09,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.7,4.68c.31.05.61.11.9.18-.3-.07-.6-.13-.9-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.73,4.95s.09-.02.13-.03c-.04.01-.09.02-.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.61,4.85c.13.03.26.06.39.1-.13-.04-.26-.07-.39-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.14,4.56s.08,0,.12,0c-.04,0-.08,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.47,4.55s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.83,4.58s.09,0,.13-.01c-.04,0-.09,0-.13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.83,24.47c-.04-.07-.09-.15-.13-.22.04.07.09.15.13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m50.86,10.87c.05.08.1.15.15.23l.03.04h0s.02.03.02.03h0s0,0,0,0c.05.08.1.16.15.25h0s0,0,0,0c.01.02.03.05.04.07h0s.05.09.08.14c.03.05.05.09.08.14h0c.05.1.1.2.15.29h0s.02.05.03.07l1.18-2.12-.03-.04-.03-.04c-.07-.11-.14-.21-.21-.32-.02-.03-.04-.05-.06-.08-.06-.09-.13-.18-.19-.27-.01-.02-.03-.04-.04-.06-.04-.05-.08-.11-.12-.16l-1.12,2.01c-.04-.06-.08-.13-.13-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.04,18.55h0s0,.03,0,.05c0-.02,0-.03,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "32.31 20.33 32.32 20.35 32.31 20.33 32.31 20.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m53.41,11.14s-.03-.06-.05-.09c-.02-.04-.04-.07-.06-.11.02.04.04.07.06.11.02.03.03.06.05.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m54.19,13.11v.04s0-.04,0-.04c-.03-.11-.06-.21-.1-.32-.01-.03-.02-.06-.03-.09.01.03.02.06.03.09.03.11.07.21.1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.01,17.97h0s0,.01,0,.01c0,.03,0,.05,0,.08,0-.03,0-.05,0-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.02,17.32h0c0,.09,0,.18,0,.28,0-.09,0-.18,0-.28h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "51.94 8.85 51.94 8.84 51.91 8.8 51.94 8.84 51.94 8.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.73,6.67h0,0s-.06,0-.1,0c.03,0,.06,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.52,21.06s-.01-.03-.02-.05c.02.07.05.15.07.22-.02-.06-.04-.11-.06-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.62,21.38h0s.02.05.03.07c0-.02-.02-.05-.03-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.42,20.73c.03.09.05.19.08.28h0s0,0,0,0c-.03-.09-.06-.18-.08-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m50.77,7.6l-.02-.02s-.08-.07-.12-.11c.04.04.08.07.12.11l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.4,20.66h0s.01.05.02.07c0-.02-.01-.05-.02-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m49.45,6.55h-.02c-.07-.06-.14-.1-.2-.15.07.04.14.09.2.13h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.79,7.47s.05.02.07.03c-.03-.01-.05-.02-.07-.03-.05-.02-.1-.04-.15-.06h.02s.09.04.13.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m48.37,5.9s-.06-.03-.09-.05c-.05-.03-.1-.05-.15-.08.05.03.1.05.15.08.03.02.06.03.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m48.56,25.6c-.06.05-.11.09-.17.14-.31.24-.63.47-.97.68-.06.03-.11.07-.17.1-.21.13-.43.25-.65.36l-1.55,2.78c-.38.1-.77.19-1.16.26,1.15-.2,2.26-.56,3.29-1.06-.19.09-.39.18-.59.27l1.96-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.63,30.1l1.18-2.12c-.29.03-.59.04-.89.04-.12,0-.23,0-.34,0l-1.12,2.01s.05,0,.07,0c.06,0,.12.01.19.02.05,0,.09,0,.14.01.06,0,.13,0,.2.01.04,0,.09,0,.13,0,.07,0,.15,0,.22,0,.04,0,.07,0,.11,0,.11,0,.22,0,.33,0,.13,0,.25,0,.38,0-.13,0-.25,0-.38,0-.07,0-.14,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.55,7.36h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.87,7.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m47.95,8.08h0s.05.03.07.04c-.02-.01-.05-.03-.07-.04l-.04-.02.04.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "47.67 7.92 47.67 7.92 47.67 7.92 47.68 7.92 47.67 7.92 47.64 7.9 47.67 7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.94,6.86h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.27,6.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.89,6.68s.04,0,.06,0c-.02,0-.04,0-.06,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m54.6,15.04v-.04s-.01-.07-.02-.1c0,.03,0,.07.01.1v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.54,6.78h0s.09.02.14.03c.04,0,.08.02.12.02.04,0,.07.02.11.02h.01s-.08-.02-.12-.02c-.04,0-.08-.02-.12-.02-.05,0-.1-.02-.14-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.42,6.75s.08.01.12.02c-.04,0-.08-.01-.12-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m52.7,16.77c0,.18,0,.37,0,.55-.01.34-.04.67-.09,1.01l1.96-3.53s.01.06.02.09c-.02-.11-.03-.23-.05-.34,0-.03,0-.06-.01-.08-.02-.13-.05-.26-.08-.4,0-.03-.01-.06-.02-.09-.02-.11-.05-.22-.08-.33,0-.03-.01-.06-.02-.09-.03-.13-.07-.25-.1-.38l-1.55,2.79c.02.26.03.53.03.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m54.68,15.93c0,.06,0,.12,0,.17l-2.98,5.37c-.25.56-.55,1.1-.89,1.61-.02.03-.04.05-.05.08l-3,5.4c-.09.05-.19.1-.28.15,4.09-2.11,7.01-6.42,7.21-11.4,0-.14,0-.29,0-.43,0-.04,0-.07,0-.11,0-.13,0-.26,0-.38v-.04c0-.14-.01-.28-.02-.42,0-.04,0-.07,0-.11,0-.08-.01-.16-.02-.24,0,.08.01.16.02.24,0,.04,0,.07,0,.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "47.02 7.57 47.04 7.58 47.02 7.57 47.02 7.57 47.02 7.57 47.02 7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.18,11.29c.54-1,1.23-1.92,2.03-2.72l.55-.98c-2.41,2.05-4.11,4.98-4.61,8.29l.94-1.69c.22-1.01.59-1.98,1.09-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.1,6.65c.23-.02.46-.02.7-.02h.03s.08,0,.12,0c.04,0,.08,0,.13,0,.03,0,.06,0,.09,0,.06,0,.12,0,.18,0,.04,0,.07,0,.11,0h0s0,0,0,0h.03s.07,0,.11,0l1.1-1.98c-.47-.07-.94-.12-1.43-.13l-1.17,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m33.98,23.96v-.02s-.06-.07-.09-.11h-.01s0-.02,0-.02h0s-.03-.04-.04-.06c-.03-.04-.06-.08-.08-.13-.01-.02-.03-.04-.04-.06l-.02-.03-.02-.03h0s-.03-.04-.04-.06l-.02-.02s-.02-.03-.03-.05c-.01-.02-.03-.05-.04-.07l-.02-.03s-.02-.04-.03-.06l-.02-.04s-.05-.08-.07-.12v-.02s-.03-.02-.03-.02h0s-.02-.03-.02-.03c-.03-.06-.07-.12-.1-.18v-.02s-.04-.05-.05-.07v-.02s-.02-.01-.02-.01l-1.17,2.1c.35.53.74,1.03,1.16,1.5-.1-.11-.2-.23-.3-.35l1.1-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m37.35,6.32c.2-.1.41-.19.62-.28l.35-.62c-.73.3-1.44.66-2.1,1.08l-.4.71c.49-.34,1-.64,1.54-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m36.78,28.97h0s0,0,0,0c.03.02.07.03.1.05-.03-.02-.07-.03-.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m35.73,25.83l-.03-.02h0s-.04-.04-.06-.05l-.03-.03s-.09-.07-.13-.11c-.02-.01-.03-.03-.05-.04l-.04-.03-.04-.03s-.06-.06-.09-.09l-.04-.04-.02-.02-1.04,1.88c-.11-.1-.23-.2-.34-.3.49.46,1.01.87,1.57,1.24-.24-.16-.48-.33-.7-.5l1.03-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.07,16.67c.32-3.2,1.98-6.02,4.36-7.85h0s1.24-2.24,1.24-2.24c-.05.03-.1.05-.14.08-.51.29-1.01.6-1.47.96-.29.21-.56.44-.83.67l-5.22,9.4h0c-.01.81.05,1.61.18,2.38l1.89-3.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.32,6.95s-.08-.02-.11-.03c-.05-.01-.09-.02-.14-.03.05.01.1.02.14.03.04,0,.08.02.11.03.05.01.1.03.14.04.04.01.07.02.11.03h0s0,0,0,0c.05.01.09.03.14.04h0s.07.02.11.03c.05.02.1.03.15.05.03.01.07.02.1.03.05.02.11.04.16.06.03.01.06.02.08.03-.03-.01-.06-.02-.08-.03-.05-.02-.09-.03-.14-.05l1.03-1.86c.13.05.26.1.39.16-.34-.15-.68-.28-1.03-.39l-1.05,1.88s-.08-.02-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m50.77,23.17s.04-.05.05-.08c-.02.03-.04.05-.05.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 52.01,
    y: 20.72,
    width: 0.01,
    height: 0,
    transform: "translate(14.76 62.52) rotate(-70.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m34.46,24.58s.04.04.05.06h0s-.04-.04-.05-.06h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 52.36,
    y: 19.55,
    width: 0.01,
    height: 0,
    transform: "translate(20.98 65.81) rotate(-76.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.52,13.58s0,.03,0,.05h0s0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m52.14,20.37v-.04s0,.04,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.85,21.14s.02-.04.03-.06h0s-.02.04-.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.71,21.48h0c-.25.56-.55,1.1-.89,1.61.34-.51.63-1.05.89-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.26,11.49s.05.09.08.14c-.03-.05-.05-.1-.08-.14l-.02-.04.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.54,13.73s0,.04,0,.06h0s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.69,18.34s-.03,0-.05,0c.02,0,.04,0,.06,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.53,18.32s.04,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.78,18.36h-.04s.04,0,.06,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m43.03,18.43s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.84,18.37s.04,0,.05.01c-.02,0-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.93,18.4s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m43.14,18.47h-.02s.03,0,.05.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.54,13.89s0,.06,0,.09h0s0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.55,14.04c0,.05,0,.1,0,.15h0c0-.05,0-.1,0-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.4,18.32s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.97,23.95s-.05-.07-.08-.11c.03.04.05.07.08.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 50.28,
    y: 23.84,
    width: 0,
    height: 0,
    transform: "translate(.5 48.7) rotate(-51.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 52.26,
    y: 19.95,
    width: 0,
    height: 0,
    transform: "translate(19.44 65.25) rotate(-74.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.33,12.71s.02.05.02.07h0s-.02-.04-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.28,12.57s.01.03.02.05v.02s0-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m52.04,13.14h0s0,0,0,0h0s0,0,0,0l-.02-.04s-.03-.08-.04-.11v-.04s.03.1.04.15c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.23,12.44v.04s.02.02.02.02c0-.02-.02-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.46 13.21 46.47 13.23 46.46 13.2 46.46 13.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.45 13.13 46.45 13.14 46.45 13.15 46.45 13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.61,12.14c.04.07.07.15.11.22-.03-.07-.07-.15-.11-.22-.01-.03-.03-.05-.04-.08h0s.03.05.04.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.17,12.3v.02s.02.02.02.02c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m51.86,12.68s-.02-.05-.03-.07c0-.02-.01-.03-.02-.05.02.04.04.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m50.6,10.51l.02.03s.02.03.03.05c-.01-.02-.02-.03-.03-.05l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.43,13.04v.04s0-.06-.01-.09c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.6,26.89c.22-.11.44-.23.65-.36-.21.13-.43.25-.65.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m48.39,25.74c-.31.24-.63.47-.97.68.33-.21.66-.44.97-.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "48.86 25.35 48.89 25.32 48.86 25.35 48.86 25.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m48.56,25.6h0c-.06.05-.11.09-.17.14.06-.04.11-.09.17-.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 49.45,
    y: 24.77,
    width: 0.02,
    height: 0,
    transform: "translate(-2.94 42.51) rotate(-45.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.49 13.37 46.49 13.37 46.49 13.37 46.49 13.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "48.62 8.54 48.62 8.54 48.59 8.51 48.62 8.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.15 12.26 46.15 12.27 46.15 12.26 46.15 12.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.5 13.43 46.51 13.46 46.51 13.47 46.5 13.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.11 12.17 46.11 12.19 46.12 12.21 46.11 12.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "42.16 18.31 42.15 18.31 42.18 18.31 42.16 18.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.48 13.28 46.48 13.3 46.48 13.31 46.48 13.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.65,21.45s.04.06.06.09c-.02-.03-.04-.07-.07-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.02,18.18s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.62,21.38s.02.05.03.07c0,.02.02.04.02.06v-.04s-.04-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.37,20.46s0-.09,0-.13c0,.05,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 32.04,
    y: 18.83,
    width: 0.04,
    height: 0,
    transform: "translate(-2.43 4.95) rotate(-8.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.72,21.56s.02.03.03.05l.03.03s-.04-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.31,22.1s.05.03.08.04h.02s-.07-.02-.11-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.9,21.77s.03.03.05.05l.03.03s-.05-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.8,21.67s.05.06.08.09c-.03-.03-.05-.06-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.99,21.87s.06.05.09.08h0s-.06-.05-.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.23,22.05s.05.03.08.05c-.03-.02-.07-.04-.1-.06l.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.09,21.95s.06.04.09.07c-.03-.02-.06-.04-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.52,21.08h0s0-.02,0-.02c.02.06.04.11.06.17v.04c0-.06-.02-.11-.04-.17v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.73,21.65s-.01-.04-.02-.05h0s.01.04.02.06c0,.02.02.04.02.06v-.02s-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "33.69 23.54 33.71 23.57 33.7 23.55 33.69 23.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "33.37 23.01 33.37 23.02 33.37 23.02 33.37 23.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.54,23.31s.03.05.04.07c-.01-.02-.02-.04-.03-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "33.62 23.43 33.63 23.45 33.63 23.45 33.62 23.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.4,23.06s.05.08.07.12c-.02-.03-.04-.07-.06-.1l-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.33,22.95s-.02-.04-.03-.05c-.02-.03-.03-.06-.05-.09.03.06.07.12.1.18v-.03s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.78,21.78h0s.02.03.03.05v.03s.02.02.02.02c0-.02-.02-.04-.02-.05,0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.87,22s.02.04.03.06h0s.01.04.01.04c-.01-.03-.03-.06-.04-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.98,22.25v.02s.01,0,.01,0l.02.04h0s-.02-.05-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.2,22.71s.03.05.04.07v-.03s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 38.79,
    y: 27.51,
    width: 0,
    height: 0.02,
    transform: "translate(.33 55.49) rotate(-71.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 34.71,
    y: 24.83,
    width: 0,
    height: 0.06,
    transform: "translate(-7.69 29.88) rotate(-42.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 39.17,
    y: 27.64,
    width: 0,
    height: 0,
    transform: "translate(2 57.91) rotate(-74.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "41.56 18.22 41.53 18.22 41.57 18.23 41.56 18.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "40.32 27.9 40.36 27.9 40.36 27.9 40.32 27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.34,18.17s-.03,0-.05-.01c.03,0,.05.02.08.02h-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 39.55,
    y: 27.72,
    width: 0,
    height: 0.03,
    transform: "translate(3.04 59.38) rotate(-75.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 36.04,
    y: 26.06,
    width: 0,
    height: 0.02,
    transform: "translate(-6.41 39.36) rotate(-53.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "41.97 18.29 41.96 18.29 41.97 18.29 41.97 18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.75,18.26h-.03s.04,0,.05,0h-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "38.41 27.38 38.43 27.39 38.43 27.39 38.41 27.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 37.01,
    y: 26.69,
    width: 0,
    height: 0.04,
    transform: "translate(-4.74 45.16) rotate(-59.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.4,20.79s.01.07.02.11c0-.04-.02-.07-.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.47,21.07v.04s.03.04.04.05c-.01-.03-.02-.06-.04-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.43,20.92h0s.02.08.03.12c-.01-.04-.02-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.58,21.33s.03.06.05.09c-.02-.03-.03-.06-.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.52,21.19s.03.07.05.11c-.02-.04-.04-.07-.05-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.08,12.13v.02s0-.03-.02-.05l.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.99,18.05h0s-.05-.02-.08-.03c.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.38,20.63s0,.07.01.1v.02s0-.08-.01-.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 41.16,
    y: 27.98,
    width: 0,
    height: 0.03,
    transform: "translate(10.11 66.9) rotate(-85.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.18,18.12h-.02s-.04-.02-.06-.03h0s.06.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.37,20.62s0-.08,0-.12c0,.04,0,.08,0,.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "35.36 25.51 35.4 25.54 35.4 25.54 35.36 25.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m33.83,23.75l-.02-.03s-.04-.06-.06-.08c.03.04.06.08.08.13h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.02,17.2s.05.04.07.06c-.03-.03-.06-.06-.1-.09h0s.03.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.12,17.29s.08.08.12.12c-.04-.04-.08-.08-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.46,17.68v.02s-.05-.08-.08-.11c.02.03.05.06.07.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.56,17.82l.03.04s-.07-.09-.1-.14c.02.03.04.06.06.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.9,18.4s.04.08.06.12c-.02-.04-.04-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.98,18.56c.02.05.04.11.06.16-.02-.05-.04-.11-.06-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.26,17.44s.06.07.09.1c-.03-.03-.06-.07-.09-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.8,18.2c.03.05.05.1.08.15-.03-.05-.05-.1-.08-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.81,11.69s.04.05.05.08c-.02-.03-.04-.05-.05-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "44.87 17.06 44.84 17.04 44.86 17.06 44.87 17.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.99,12.22s.04,0,.06.01c-.02,0-.04,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.95,11.89h0s-.04-.05-.06-.08c.02.03.03.05.05.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.74,16.96s-.03-.02-.05-.04l.03.02h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.82,17.03s-.05-.04-.07-.06l.02.02s.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.05,18.75s.03.1.05.14c-.02-.05-.03-.1-.05-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m43.09,12.24s.04,0,.05.01c-.02,0-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.95,17.14s-.05-.04-.08-.06l.03.02s.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m43.19,12.26s.03.01.05.02c-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.23,19.41s0,.04.01.06c0-.05-.02-.09-.03-.14,0,.03,0,.05.01.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.75,18.11s.03.06.05.09c-.03-.05-.06-.1-.09-.15,0,.02.02.03.03.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.4,12.94s-.02-.06-.03-.09c0,.03.02.06.03.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.62,14.2s0,.08,0,.12h0s0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.16,10.98s.05.04.08.07c-.03-.02-.05-.04-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.01,12v.02s-.02-.05-.03-.08c.01.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "46.04 12.05 46.04 12.05 46.05 12.07 46.04 12.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.92,10.79s.05.04.07.05c-.02-.02-.05-.04-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.48,10.52s.04.02.06.03h.01s.04.03.06.04c-.04-.03-.09-.05-.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.24,20.86c-.02.1-.04.2-.06.3.02-.1.05-.2.06-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.25,19.53c0,.05.01.1.02.15,0-.05-.01-.1-.02-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.27,19.71c0,.06.01.12.01.18,0-.06,0-.12-.01-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.16,19.12c.01.06.03.12.04.17-.01-.06-.03-.12-.04-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m43.39,12.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.66,17.96l.03.04s-.05-.07-.07-.11c.01.02.02.03.03.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.11,18.94s.03.09.04.13c-.01-.05-.02-.09-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.29,19.94s0,.1,0,.14c0-.05,0-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m46.29,20.14c0,.06,0,.13,0,.19,0-.06,0-.13,0-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.63,16.88h.02s-.07-.04-.11-.06l.03.02s.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.62,14.45v.03s0,0,0,0c0-.03,0-.06,0-.09,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.22,15.71s-.05-.05-.07-.07c.02.03.05.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.38,11.18s.03.03.05.05h0s-.04-.03-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.13,15.62s-.05-.06-.08-.09c.03.03.05.06.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m35.27,25.42s.06.06.09.09c-.03-.03-.06-.06-.09-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.31,15.79h0s-.05-.04-.07-.06c.02.02.04.04.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m41.04,15.51s-.04-.05-.06-.08c.02.03.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.63,11.46v.02s.05.04.05.04c-.02-.02-.03-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 41.43,
    y: 15.88,
    width: 0,
    height: 0,
    transform: "translate(4.51 40.49) rotate(-54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.79,15.1v.02s.02.02.02.02c0-.02-.02-.03-.02-.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.96,15.41s-.04-.07-.07-.1c.02.03.04.07.07.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.75,15.02s-.01-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "45.53 11.33 45.53 11.34 45.51 11.32 45.53 11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.7,14.86h0s0,.03,0,.03c0-.02-.01-.04-.02-.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.54,11.35h.01s.03.05.03.05c-.02-.02-.03-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m35.71,25.81l.03.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "45.44 11.24 45.45 11.25 45.48 11.29 45.44 11.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.85,15.23h0s.02.04.03.06c-.01-.02-.03-.05-.04-.08v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.64,14.61h0s0,.02,0,.02c0-.03,0-.05-.01-.08,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "44.35 16.71 44.32 16.69 44.33 16.69 44.35 16.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.79,10.7s.05.04.08.05c-.03-.02-.05-.04-.08-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "45.34 11.14 45.34 11.15 45.37 11.17 45.34 11.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.04,10.88s.05.04.07.06c-.02-.02-.05-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.89,12.2s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.65,12.18s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.78,12.19s.05,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.48,16.79h.02s-.1-.05-.15-.08c.02.01.04.02.06.04.02.01.05.03.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m42.8,27.98h0c-.29.03-.59.04-.89.04-.12,0-.23,0-.34,0,.11,0,.23,0,.34,0,.3,0,.6-.01.89-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m35.49,25.62h0s.08.07.13.11c-.04-.04-.09-.07-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.72,11.57h0s.03.05.04.07c-.02-.02-.04-.05-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m40.67,14.73v.03s0,0,0,0c0-.02-.01-.05-.01-.07v.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.64,10.61h.02s0,.02,0,.02c.02.01.05.03.07.04-.03-.02-.06-.04-.1-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "45.62 11.44 45.62 11.45 45.62 11.44 45.62 11.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m44.3,16.68s-.06-.03-.09-.05c.02,0,.03.02.05.03l.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m45.33,11.13h0s-.04-.03-.07-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m47.67,7.92l-.04-.02c-1.12-.44-2.33-.68-3.62-.68-5.71,0-10.53,4.79-10.77,10.7-.02.37-.01.73,0,1.09-.03-.01-.06-.03-.09-.04.03.01.06.03.09.04.02.32.05.64.1.96,0,.04.01.07.02.11.11.69.28,1.36.52,2,1.56.94,3.45,1.48,5.5,1.48.11,0,.21,0,.32,0-.02-.01-.03-.03-.05-.04-.02-.02-.04-.04-.06-.05-.02-.01-.03-.03-.04-.04-.02-.02-.04-.04-.06-.06l-.02-.02c-.05-.05-.11-.11-.16-.17l-.02-.02s-.04-.05-.07-.08l-.03-.03s-.04-.05-.06-.08l-.03-.03s-.04-.06-.06-.08l-.02-.03s-.04-.06-.06-.09v-.02c-.13-.19-.24-.39-.33-.6h0c-.02-.05-.03-.09-.05-.13v-.02s-.04-.08-.05-.12h0c-.07-.24-.13-.47-.16-.71h0c-.03-.24-.05-.5-.04-.75h2.03l.25.12c-.03.76.35,1.43.94,1.77h0c.21.08.43.13.66.13s.46-.04.67-.12c.09-.03.18-.07.26-.12.06-.03.11-.06.16-.1.19-.13.35-.28.49-.46.04-.05.08-.11.11-.16.1-.17.19-.35.24-.54.04-.13.06-.26.08-.4,0-.03,0-.07,0-.1.01-.31-.04-.61-.16-.87-.02-.06-.05-.12-.08-.17-.17-.3-.41-.55-.7-.73-.21-.08-.43-.13-.67-.13-.59,0-1.14-.13-1.63-.37l-.25-.12.04.02s-.04-.02-.05-.03h-.01s-.08-.05-.12-.07h0c-.39-.22-.74-.5-1.04-.83l-.02-.02c-.11-.12-.21-.25-.3-.39h0c-.04-.08-.08-.14-.12-.2l-.02-.04c-.04-.07-.08-.14-.11-.21h0c-.04-.08-.07-.15-.1-.23v-.03c-.04-.07-.06-.13-.09-.2,0-.02-.01-.03-.02-.05-.15-.46-.22-.95-.2-1.47.08-1.86,1.35-3.43,3.01-3.93.05-.01.09-.03.14-.04v-.23s.05-1,.05-1h1.99l.25.12-.05,1.18c.15.05.3.12.44.19h.01s.03.02.03.02c-.03-.02-.06-.03-.09-.04l.25.12c1.35.65,2.25,2.07,2.18,3.74h-2.04l-.25-.12h0s0-.1,0-.15v-.03s0-.09-.01-.14v-.02s-.01-.09-.02-.13v-.02s-.02-.09-.04-.13v-.03c-.03-.09-.07-.18-.1-.26v-.02s-.05-.08-.07-.12h0s-.05-.09-.07-.13h0s-.05-.08-.08-.12h0c-.06-.08-.13-.16-.2-.22h0c-.1-.1-.21-.18-.33-.25-.21-.08-.43-.12-.66-.12-1.07,0-1.98.9-2.03,2.01-.03.76.35,1.42.94,1.76l.04.02h.01c.09.04.19.06.28.08h.02s.09.02.14.02h.03s.1,0,.15,0c.07,0,.13,0,.19,0,.02,0,.04,0,.06,0,.04,0,.09,0,.13.01.02,0,.05,0,.07,0,.04,0,.08,0,.11.02.03,0,.05,0,.08.01.04,0,.07.01.11.02.03,0,.05.01.08.02.03,0,.07.02.1.03.03,0,.05.01.08.02.03,0,.07.02.1.03.03,0,.05.02.08.02.03.01.07.02.1.04.02,0,.05.02.07.03.04.02.08.03.12.05.04.02.07.03.1.05.03.01.05.02.08.04l-.04-.02.25.12c1.35.65,2.25,2.09,2.18,3.75,0,.22-.04.44-.08.65,2.15-1.71,3.57-4.19,3.7-6.93.06-1.29-.17-2.53-.64-3.65v-.02s-.02-.04-.02-.04c-.03-.08-.07-.16-.1-.24,0-.02-.02-.04-.03-.06-.01-.02-.02-.04-.03-.07-.03-.07-.07-.14-.11-.21v-.02c-.05-.08-.1-.16-.14-.24-.01-.02-.03-.04-.04-.07-.05-.08-.1-.17-.15-.25h0c-.05-.09-.11-.18-.16-.26-.01-.02-.03-.04-.04-.06-.05-.07-.1-.14-.15-.22l-.02-.03c-.06-.08-.12-.16-.18-.24-.02-.02-.03-.04-.05-.06-.05-.07-.11-.13-.16-.19l-.03-.04s-.06-.07-.09-.1h.02c.09.07.17.12.26.18-.04-.03-.08-.05-.12-.08-.04-.03-.09-.06-.13-.09-.02-.02-.05-.03-.07-.04h0l-.04-.02c-.07-.04-.15-.09-.22-.13h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m49.66,9.43s.04.04.05.05c.06.06.12.13.19.19.02.02.03.03.05.05-.02-.02-.03-.03-.05-.05-.06-.06-.12-.13-.19-.19-.02-.02-.04-.04-.05-.05-.03-.03-.07-.07-.1-.1h0s.08.06.11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.88,23.83h.01c.03.05.05.09.08.12v.02s.02,0,.02,0c-.04-.05-.07-.1-.1-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m44.88,23.35c.12-.11.24-.23.35-.36-.11.13-.23.25-.35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m43.75,24.09h0c-.1.04-.2.08-.3.12h0c.27-.09.52-.22.76-.36-.15.09-.3.17-.46.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m34.46,24.58s.04.04.05.06h0s-.05-.05-.07-.08l.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "40.66 24.13 40.65 24.13 40.68 24.14 40.66 24.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "43.12 24.97 43.14 24.3 43.16 24.3 43.14 24.3 43.12 24.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m34.69,24.84l.04.04h0s-.04-.04-.06-.06h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.48,23.2s-.05-.08-.07-.12c.02.03.04.07.06.1l.02.04v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.55,23.32s.02.04.03.05c.01.02.02.03.03.05v.02s-.04-.08-.06-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m43.3,24.26h0s.1-.03.14-.05h0s-.09.03-.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m35.49,25.62s.08.07.13.11c-.04-.04-.09-.07-.13-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m34.24,24.31h.01s.03.05.05.07c-.02-.03-.05-.06-.07-.09v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m32.67,21.51v.02s0-.04-.01-.05v.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "32.87 22 32.87 22 32.87 22.01 32.87 22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m38.07,27.24h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m32.75,21.71v.02s.02.03.03.05h0s-.02-.04-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m43.09,25.48v-.22s0,.22,0,.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "33.01 22.32 33.01 22.33 33.01 22.31 33.01 22.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.34,22.96v.03s.03.03.03.03h0s-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.7,23.55v.02s.04.04.05.06c.02.03.04.06.06.08-.04-.05-.07-.11-.11-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m41.15,24.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "40.8 24.19 40.79 24.19 40.83 24.2 40.8 24.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "36.03 26.06 36.05 26.07 36.06 26.08 36.01 26.05 36.03 26.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m44.75,23.46c-.13.11-.26.21-.4.3.14-.09.27-.19.4-.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "37.33 26.89 37.36 26.91 37.35 26.9 37.33 26.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "32.53 21.11 32.52 21.08 32.52 21.08 32.53 21.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m35.4,25.54s-.09-.08-.13-.12c.03.03.06.06.09.09l.04.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m42.8,27.98h0c1.35-.12,2.63-.5,3.8-1.1.22-.11.44-.23.65-.36.06-.03.11-.07.17-.1.33-.21.66-.44.97-.68.06-.04.11-.09.17-.14.1-.08.2-.17.3-.25l.03-.02c.2-.17.39-.36.57-.54l.02-.02c.28-.29.55-.6.81-.92h0c.17-.22.33-.44.48-.67.02-.03.04-.05.05-.08.34-.51.63-1.05.89-1.61.05-.11.1-.22.14-.34,0-.02.02-.04.03-.06.05-.12.09-.23.13-.35h0c.04-.13.08-.25.12-.36v-.04c.05-.12.09-.25.13-.37h0c.04-.13.07-.26.1-.39h0c.1-.41.17-.82.23-1.23.04-.33.07-.67.09-1.01,0-.18.01-.37,0-.55,0-.27-.01-.53-.03-.79h0c0-.12-.02-.23-.03-.35,0-.02,0-.04,0-.06-.01-.1-.02-.19-.04-.28,0-.02,0-.04,0-.06-.02-.11-.04-.22-.06-.33v-.02c-.02-.1-.04-.2-.06-.3,0-.03-.01-.05-.02-.08-.02-.09-.04-.18-.06-.27,0-.02,0-.03-.01-.05-.03-.1-.06-.21-.09-.31,0-.02-.01-.05-.02-.07-.02-.08-.05-.16-.08-.24,0-.03-.02-.06-.03-.08-.03-.1-.07-.2-.1-.3h0s0-.01,0-.01h0s-.01-.04-.02-.05c-.02-.05-.04-.1-.06-.15-.02-.04-.03-.08-.05-.12,0-.02-.02-.04-.03-.07-.01-.03-.02-.05-.03-.08-.02-.04-.04-.08-.05-.12-.02-.04-.03-.08-.05-.12v-.02s-.03-.04-.04-.05c-.03-.07-.07-.15-.11-.22-.01-.03-.03-.05-.04-.08-.05-.09-.1-.19-.15-.28h0c-.03-.06-.05-.11-.08-.15-.03-.05-.05-.1-.08-.14l-.02-.04-.02-.04h0c-.05-.08-.1-.17-.15-.25h0s-.02-.03-.02-.03l-.03-.04c-.05-.08-.1-.15-.15-.23-.02-.02-.03-.04-.05-.07l-.03-.04c-.04-.06-.09-.12-.13-.18-.01-.02-.02-.03-.03-.05l-.02-.03s-.03-.03-.04-.05c-.04-.06-.09-.12-.14-.17-.01-.02-.03-.04-.04-.06h0s-.07-.09-.1-.13c-.02-.03-.05-.06-.07-.08h0s-.03-.04-.04-.05c-.06-.07-.13-.14-.19-.21l-.02-.02s-.03-.03-.05-.05c-.06-.06-.12-.13-.19-.19-.02-.02-.04-.04-.05-.05-.04-.04-.07-.07-.11-.11-.04-.04-.08-.08-.12-.11h0s-.04-.04-.04-.04c-.07-.06-.13-.12-.2-.18-.02-.02-.04-.04-.06-.05-.08-.07-.16-.14-.25-.2l-.03-.03h0c-.07-.06-.15-.12-.22-.17l-.03-.02-.03-.02c-.09-.06-.17-.13-.26-.19h-.01c-.08-.07-.17-.12-.26-.18h-.02s.06.06.09.09l.03.04c.05.06.11.13.16.19.02.02.03.04.05.06.06.08.12.16.18.24l.02.03c.05.07.1.14.15.22.01.02.03.04.04.06.06.08.11.16.16.25h0c.05.09.1.17.15.26.01.02.03.04.04.07.05.08.09.16.13.24v.02c.05.07.08.14.12.21.01.02.02.04.03.07,0,.02.02.04.03.06.04.08.07.16.1.24l.02.04v.02c.48,1.12.71,2.36.65,3.65-.13,2.75-1.55,5.22-3.7,6.93-.32,1.62-1.54,2.92-3.07,3.32l-.05,1.22h-1.99l-.25-.12h0l.05-1.18c-.13-.05-.26-.1-.39-.16l-.25-.12h.01s0,0,0,0c-.03-.01-.06-.03-.08-.04-.02,0-.04-.02-.05-.03-.03-.02-.06-.03-.09-.05l-.04-.02s-.08-.05-.12-.08c-.02-.01-.03-.02-.05-.03-.03-.02-.05-.03-.07-.05-.02-.01-.04-.03-.06-.04-.02-.02-.04-.03-.06-.05-.02-.01-.04-.03-.06-.05-.02-.02-.04-.03-.06-.05-.02-.02-.04-.03-.06-.05h0c-.11,0-.21,0-.32,0-2.05,0-3.94-.54-5.5-1.48.83,2.25,2.39,4.12,4.41,5.27.04.02.08.03.12.05h.03c.11.05.23.09.35.13h.01c.12.05.25.09.37.12h0c.12.04.24.07.37.1h.03c.25.07.5.12.76.16h.04c.26.05.52.08.78.1h.03c.13.01.26.02.39.02.11,0,.23,0,.34,0,.3,0,.6-.01.89-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m36.69,26.52h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.24,22.78v-.02s0,.03,0,.03v.02s.04.06.06.09c-.02-.04-.04-.07-.06-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m33.83,23.75h0s.03.04.04.06c-.01-.02-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m46.12,21.37c-.04.15-.1.3-.16.44.06-.14.11-.29.16-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m45.92,21.9c-.04.09-.08.17-.12.26.04-.08.09-.17.12-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m45.66,22.39c-.1.16-.21.32-.33.47.12-.15.23-.3.33-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m36.99,26.7l.03.02h.01s-.03-.01-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m34.96,25.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m35.73,25.83h0l.02.02s-.03-.03-.05-.04l.03.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "40.96 24.24 40.95 24.24 40.99 24.25 40.96 24.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m49.17,6.27l-1.23-.59.04.02h0c.05.02.1.05.15.08.05.03.1.05.15.08.03.02.06.03.09.05.11.06.23.12.34.19h.02c.1.07.21.14.31.2.03.02.06.04.09.05.03.02.07.04.1.07.07.04.14.09.2.13h.02c.11.08.21.16.31.23.03.02.05.04.08.06.09.07.18.14.27.21l.04.03c.1.08.2.16.29.24.02.02.05.04.07.06.04.04.08.07.12.11.04.04.08.07.12.11l.02.02.04.03c.09.09.18.17.27.26.02.02.04.04.06.06.07.07.15.15.22.23.02.02.04.04.06.06.09.09.17.19.25.28.02.02.04.04.05.06.06.07.11.14.17.2l.03.04h0s.04.05.05.07c.04.05.07.09.11.14.04.05.08.11.12.16.01.02.03.04.04.06.07.09.13.18.19.27.02.03.04.05.06.08.07.11.14.21.21.32l.03.04.03.04c.05.08.1.17.16.25.02.03.03.06.05.09.07.11.13.22.19.34h0c.04.09.08.16.12.24.02.04.04.07.06.11.02.03.03.06.05.09.05.11.11.22.16.33v.03c.07.12.12.24.17.36.01.03.03.06.04.09.04.11.09.21.13.32,0,.02.01.04.02.06.05.12.09.25.13.37.01.03.02.06.03.09.03.11.07.21.1.32v.04s.02.04.02.04h0c.04.13.07.26.1.38,0,.03.01.06.02.09.03.11.05.22.08.33,0,.03.01.06.02.09.03.13.05.26.08.4,0,.03,0,.06.01.08.02.11.04.22.05.34,0,.03,0,.07.01.1v.04c.02.12.04.24.05.36,0,.02,0,.05,0,.07,0,.04,0,.08,0,.12,0,.08.01.16.02.24,0,.04,0,.07,0,.11,0,.14.02.28.02.42v.04c0,.13,0,.26,0,.38,0,.04,0,.07,0,.11,0,.14,0,.29,0,.43-.2,4.97-3.12,9.28-7.21,11.4h-.03c-.09.06-.18.1-.27.15h-.01c-1.03.5-2.14.87-3.29,1.06h-.04c-.12.03-.24.05-.36.06h-.03c-.13.02-.26.04-.4.05h-.01c-.12.01-.24.02-.36.03-.03,0-.07,0-.1,0-.09,0-.19.01-.28.01-.04,0-.07,0-.11,0-.13,0-.25,0-.38,0-.11,0-.22,0-.33,0-.04,0-.07,0-.11,0-.07,0-.15,0-.22,0-.04,0-.09,0-.13,0-.07,0-.13,0-.2-.01-.05,0-.09,0-.14-.01-.06,0-.12-.01-.19-.02-.02,0-.05,0-.07,0-.02,0-.05,0-.07,0-.06,0-.12-.01-.18-.02-.05,0-.09-.01-.14-.02-.06,0-.12-.02-.18-.03-.05,0-.09-.02-.14-.02-.06-.01-.12-.02-.17-.03-.05,0-.09-.02-.14-.03-.03,0-.06-.01-.09-.02-.03,0-.06-.01-.09-.02-.02,0-.03,0-.05-.01-.03,0-.06-.01-.09-.02-.06-.01-.11-.03-.17-.04-.05-.01-.09-.02-.14-.03-.06-.02-.11-.03-.17-.05-.04-.01-.09-.02-.13-.04-.03,0-.06-.02-.09-.03-.03,0-.05-.02-.08-.02-.04-.01-.09-.03-.13-.04h-.03s-.09-.04-.14-.06c-.04-.01-.08-.03-.12-.04-.06-.02-.12-.04-.18-.07-.04-.01-.07-.03-.11-.04-.07-.03-.14-.06-.22-.09-.02,0-.05-.02-.07-.03-.1-.04-.19-.08-.28-.12-.02-.01-.05-.02-.07-.03-.03-.02-.07-.03-.1-.05-.03-.02-.07-.03-.1-.05h-.01s1.23.58,1.23.58c1.53.73,3.24,1.14,5.06,1.14,6.82,0,12.58-5.72,12.87-12.78.21-5.17-2.57-9.63-6.76-11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m33.88,22.06c-.23-.64-.41-1.31-.52-2,0-.04-.01-.07-.02-.11-.05-.32-.08-.64-.1-.96-.03-.01-.06-.03-.09-.04.03.02.06.03.09.04-.02-.36-.02-.72,0-1.09.24-5.91,5.07-10.7,10.77-10.7,1.28,0,2.5.24,3.62.68-.08-.05-.16-.09-.25-.14-.02-.01-.05-.03-.07-.04-.08-.04-.17-.09-.25-.13l-.04-.02h0c-.05-.02-.1-.05-.15-.07-.03-.01-.05-.03-.08-.04-.04-.02-.09-.04-.13-.06h-.02s-.06-.03-.09-.05h-.04c-.07-.04-.14-.07-.2-.1-.03-.01-.06-.02-.09-.03-.05-.02-.1-.04-.15-.06-.03-.01-.07-.02-.1-.04-.05-.02-.1-.03-.14-.05-.04-.01-.07-.02-.11-.03h0s-.09-.03-.14-.04h0s-.08-.02-.11-.03c-.05-.01-.09-.03-.14-.04-.04-.01-.08-.02-.12-.03-.05-.01-.09-.02-.14-.03-.04,0-.08-.02-.12-.03h-.02s-.01,0-.01,0c-.04,0-.07-.02-.11-.02-.04,0-.08-.02-.12-.02-.05,0-.09-.02-.14-.03h0s-.08-.01-.12-.02c-.05,0-.1-.02-.14-.02-.04,0-.08-.01-.12-.02-.03,0-.06,0-.09-.01-.02,0-.04,0-.06,0-.04,0-.08,0-.12-.01-.05,0-.1-.01-.15-.01h0s-.08,0-.12-.01h-.01s0,0,0,0c-.04,0-.07,0-.11,0h-.03s0,0,0,0c-.04,0-.08,0-.11,0-.06,0-.11,0-.17,0-.03,0-.07,0-.1,0-.04,0-.08,0-.13,0-.04,0-.08,0-.12,0h-.03c-.23,0-.46,0-.7.02-.52.04-1.04.11-1.54.23h0c-.25.06-.5.12-.74.2h0c-.24.08-.49.16-.72.25h0c-.24.09-.47.19-.7.3h0c-.23.11-.46.23-.68.35h0c-.22.13-.44.26-.65.4h0c-.21.14-.42.29-.62.44-2.39,1.83-4.04,4.65-4.36,7.85-.01.1-.02.21-.03.31v.02c0,.11-.02.21-.02.32h0c0,.09,0,.18,0,.28,0,.03,0,.06,0,.09,0,.06,0,.12,0,.19,0,.03,0,.06,0,.08h0s0,.03,0,.03c0,.03,0,.05,0,.08,0,.03,0,.05,0,.08v.03s0,.01,0,.01c0,.02,0,.04,0,.06h0s0,.06,0,.08c0,.07,0,.14.01.21h0s0,.03,0,.05c0,.03,0,.05,0,.08,0,.03,0,.05,0,.08h0s0,0,0,0h0s0,.04,0,.04h0s0,.05,0,.05h0s0,.05,0,.08c0,.03,0,.07.01.1,0,.05.01.1.02.15,0,.04,0,.07.01.11,0,.03,0,.06.01.09,0,.03,0,.06.01.1.02.11.04.22.06.33,0,.02,0,.04.01.07.01.07.03.13.04.2,0,.03.02.07.02.1.01.05.03.11.04.16h0s0,.02,0,.02v.03c.03.09.06.19.08.28h0s.01.05.02.07c.03.09.05.19.08.28h0s.01.03.02.05h0s0,.02,0,.02v.02c.03.06.04.11.06.17.01.03.02.06.03.09h0s0,.01,0,.01c.01.03.02.07.04.1,0,.02.01.04.02.05,0,.02.02.05.03.07,0,.02.01.04.02.05,0,.02.01.03.02.05.01.03.02.05.03.08,0,.02.01.03.02.05,0,.02.01.04.02.05.02.04.03.08.05.11h0s.03.07.04.1c.02.05.04.1.07.15,0,.02.02.04.03.06v.02c.06.12.12.24.18.35h0s0,.01,0,.01v.02s.03.03.04.05v.02s.05.07.07.11c0,.02.02.04.03.05h0s.02.05.03.07h0s.01.02.01.02v.02s.03.03.03.03c.02.04.04.08.07.12v.02s.03.04.05.06l.02.03v.02s.06.08.09.12h0s.03.05.04.07h0s.02.03.02.03h0c.04.07.07.12.11.18l.02.03h0s.03.05.04.07h0s0,0,0,0c.03.05.07.1.1.15.08.11.16.22.25.32.02.03.05.06.07.09.05.06.09.11.14.17.02.03.05.06.07.09.05.06.11.12.16.18.02.02.04.04.06.06.07.08.15.16.22.23h0c.08.09.17.17.25.25h0s.02.02.02.02l.04.04h0s.08.08.13.12h0s.04.03.04.03c.02.02.03.03.05.04h0s.08.07.13.11l.03.03s.04.03.06.05h0s.03.03.05.04c.08.07.17.14.26.2l.04.03c.1.07.19.14.29.21h0c.1.08.21.15.31.21h.02c.1.07.19.13.29.19.02.01.03.02.05.03.1.06.2.11.3.17h.01s.01.01.01.01c.22.12.45.22.68.32h.03c.07.04.15.07.22.1-2.02-1.15-3.58-3.02-4.41-5.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m43.72,10.22c.08.02.17.05.25.08l.05-1.18-.25-.12-.05,1.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m43.12,18.46l-.04-.02s-.03-.01-.05-.02l-.04-.02s-.03-.01-.05-.02h-.04s-.04-.02-.05-.03h-.04s-.04-.02-.06-.02h-.04s-.04-.01-.06-.02h-.04s-.04,0-.07-.01h-.04s-.07,0-.1,0h0c-.06,0-.12,0-.18,0h-.03s-.03,0-.03,0c-.04,0-.08,0-.13-.01-.02,0-.03,0-.05,0h-.02c-.05,0-.1-.01-.15-.02h-.03s-.04-.01-.05-.02c-.03,0-.06-.01-.08-.02-.02,0-.04,0-.06-.01h-.04s-.04-.02-.07-.03c-.03,0-.06-.02-.09-.02-.03,0-.05-.01-.08-.02h-.04s-.05-.03-.07-.04c-.03,0-.06-.02-.08-.03-.03-.01-.06-.02-.09-.04h0s-.05-.03-.08-.04c-.03-.01-.07-.03-.1-.04l-.04-.02.25.12c.49.24,1.04.37,1.63.37.24,0,.47.05.67.13-.05-.03-.1-.05-.14-.07-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m40.37,20.5s0,.08,0,.12h0c0,.06.01.1.02.14v.03s.02.07.03.11v.02s.03.08.04.12v.03s.03.07.05.1v.02s.04.07.06.11v.02s.04.06.06.09v.02s.06.07.08.1v.02s.05.05.08.08l.02.02s.05.06.08.09h.01s.05.06.07.09l.02.02s.06.05.09.08h0s.06.05.09.07l.03.02s.07.04.1.06h0s.07.04.11.06c.04.02.09.04.14.06-.59-.34-.98-1.01-.94-1.77l-.25-.12s0,.09,0,.13v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m41.15,24.3s-.1-.03-.15-.04h-.01s-.04-.02-.04-.02c-.03-.01-.06-.02-.09-.03h-.03s-.04-.02-.04-.02c-.03-.01-.05-.02-.08-.03l-.04-.02h-.03s-.05-.03-.07-.05c-.02,0-.03-.01-.05-.02h-.01s.25.11.25.11c.13.06.26.11.39.16v-.04s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m44.61,10.59l.03.02s.07.04.1.06c.02,0,.03.02.05.03.03.02.05.04.08.05.02.01.03.02.05.03.03.02.05.04.07.05.02.01.03.02.05.04.02.02.05.04.07.06l.04.04s.05.04.08.07l.04.03s.05.04.07.06h0s.03.03.03.03h0s.04.05.06.07h0s.04.05.04.05l.03.03.02.02h0s.03.04.05.06l.04.04h0s0,.01,0,.01c.02.02.03.04.05.06l.03.04h0s.04.05.05.08c.01.02.02.03.04.05.02.03.04.05.05.08.01.02.02.03.03.05.02.03.04.06.06.09v.02s.03.02.03.02c.02.03.03.05.05.08v.02s.03.03.03.03v.02s.03.03.04.05v.03s.03.04.03.04c0,.02.02.03.02.05h0s.02.05.02.05c0,.02.01.03.02.05,0,.02.02.04.02.05v.03s.03.04.04.06c0,.02.01.04.02.05v.03s.03.05.04.07c0,.02.01.03.02.05v.02s.02.06.03.09c0,.02,0,.03.01.05h0s.02.07.03.1c0,.02,0,.03.01.05h0s.01.07.02.1c0,.02,0,.03.01.05v.02s.01.04.01.04v.03s.01.04.02.05v.03s.01.04.01.06h0s0,.04,0,.06v.04s.01.04.01.06c0,.02,0,.03,0,.05,0,.02,0,.04,0,.05,0,.02,0,.04,0,.06v.04s0,.05,0,.07c0,.02,0,.04,0,.06v.02s0,.06,0,.09c0,.02,0,.04,0,.05h0c0,.06,0,.12,0,.17h-2.04l.25.12h2.04c.07-1.66-.83-3.09-2.18-3.74l-.25-.12s.06.03.09.04l.03.02s.09.05.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.2,23.02s-.04-.05-.06-.08c.02.03.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.29,23.13s-.04-.05-.07-.08c.02.03.04.05.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.11,22.9s-.04-.06-.06-.08c.02.03.04.06.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.46,23.31c-.05-.05-.11-.11-.16-.17.05.06.1.11.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.65,23.49s-.04-.04-.06-.05c.02.02.04.04.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.02,22.78s-.04-.06-.06-.09c.02.03.04.06.06.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.55,23.4s-.04-.04-.06-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.9,22.22c.09-.03.18-.07.26-.12-.08.05-.17.09-.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.16,22.1c.06-.03.11-.06.16-.1-.05.04-.11.07-.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.1,19.46c-.02-.06-.05-.12-.08-.17.03.06.06.11.08.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.18,12.33s.02.05.03.08c0-.02-.02-.04-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.53,21.79c-.07-.23-.13-.46-.16-.7.03.24.09.48.16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.63,22.06s-.03-.08-.05-.12c.01.04.03.08.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.58,21.92s-.03-.08-.04-.12c.01.04.03.08.04.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.95,22.67c-.12-.19-.22-.39-.31-.6.09.21.19.41.31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.33,20.33c-.01.26,0,.51.04.75l.42-.75h-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.1,18.09s-.07-.02-.1-.04c.03.01.06.02.09.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.39,22.14c.06.03.11.05.17.08h0s-.09-.04-.14-.06h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.74,17.94s-.08-.04-.12-.06c.04.02.08.04.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.99,18.05c-.08-.03-.16-.07-.23-.1.02,0,.04.02.05.03.03.02.07.03.1.04.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.35,12.78s.01.04.02.06c0-.02,0-.03-.01-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.24,12.47s.02.05.03.07c0-.02-.01-.04-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.51,13.46s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.3,12.62s.02.05.03.07c0-.02-.01-.03-.02-.05v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.53,13.63s0,.05,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "46.54 14.2 46.54 14.2 44.51 14.2 44.51 14.2 44.51 14.2 46.54 14.2 46.54 14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.54,13.8s0,.04,0,.07c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.48,10.52l-.03-.02h-.03s.08.03.12.05c-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.25,16.65s-.03-.02-.05-.03l-.03-.02s.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.64,11.47s.05.06.07.09l-.03-.04-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.51,14.02v.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.74,18.09s-.02-.03-.03-.05l-.03-.04-.03-.04s.05.09.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.57,16.84l-.03-.02-.04-.03h-.02s.06.03.09.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "40.62 14.32 40.62 14.36 40.62 14.33 40.62 14.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.98,12.3h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.16,12.25h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.89,12.34h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.07,12.27h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.41,16.74s-.04-.02-.06-.04h0s-.02-.01-.02-.01c.03.02.06.03.08.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.67,14.75v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.23,19.41s0-.05-.01-.08v-.04c-.02-.06-.03-.12-.05-.17v-.04s-.04-.09-.05-.13c0-.02-.01-.03-.02-.05-.02-.05-.03-.1-.05-.14v-.03c-.03-.05-.05-.11-.07-.16l-.02-.04s-.04-.08-.06-.12c0-.02-.01-.03-.02-.05-.03-.05-.05-.1-.08-.15h0s-.03-.06-.05-.09c.23.39.39.83.48,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.81,12.38h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.7,14.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.91,13.21l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.43,15.88h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.86,13.3l.02-.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.8,15.12v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.72,12.42l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.96,13.13l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.65,17.94s-.02-.03-.03-.05l-.03-.04-.03-.04s.06.08.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.01,13.05l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.55,17.8s-.04-.06-.06-.09l-.02-.02v-.02s.05.08.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.86,17.06h-.02s-.02-.03-.02-.03c-.02-.01-.03-.03-.05-.04.03.02.06.05.09.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.99,17.17h0s-.04-.04-.04-.04c-.02-.01-.03-.03-.05-.04.03.03.06.05.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.46,17.67s-.05-.06-.07-.09l-.03-.04s-.06-.07-.09-.1l-.03-.03s-.08-.08-.12-.12l-.03-.03s-.04-.04-.07-.06c.16.14.3.3.43.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.07,12.97l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.56,12.52l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.48,12.57l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.13,12.9l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.64,12.47l.03-.02-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.41,12.63l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.33,12.69l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.2,12.83l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.26,12.76l.03-.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.78,16.44s.05.02.07.03c-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.1,12.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.18,13.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.89,12.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.26,13.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.78,13.47s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.74,13.57s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.71,13.66s.01-.03.02-.05c0,.02-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.84,16.1h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.33,13.28v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.44,13.57v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.11,16.39c-.04-.07-.08-.14-.11-.21.04.07.07.14.11.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.25,16.62c-.04-.06-.08-.13-.12-.19.04.07.08.13.12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.88,15.92c-.03-.07-.05-.13-.07-.2.02.07.05.13.07.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m38.99,16.18c-.04-.07-.07-.15-.1-.23.03.08.07.15.1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.47,13.73v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.68,13.76s0-.04.01-.05c0,.02,0,.04-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.49,13.88v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.86,16.23s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.97,16.52s.07.03.1.05c-.03-.02-.07-.03-.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.6,16.38s.05.02.08.02c-.02,0-.05-.02-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.82,13.38l.02-.05s-.01.03-.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.72,16.95l-.03-.02-.04-.03h-.02s.06.03.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.63,14.06s0-.04,0-.07c0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.63,14.48v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.56,17.02c-.11-.12-.21-.25-.3-.39.09.14.19.27.3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.62,14.19s0-.06,0-.1c0,.03,0,.06,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.64,13.96s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.14,16.18h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.3,16.2h.03s-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.66,13.85s0-.04.01-.06c0,.02,0,.04-.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.67,16.21s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.05,16.25s.05,0,.08.01c-.03,0-.05,0-.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.24,16.29s.05.01.08.02c-.03,0-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.42,16.33s.05.01.08.02c-.03,0-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.64,14.61h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.3,24.26s.09-.03.14-.05c-.05.02-.09.03-.14.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.13,23.85s-.03-.02-.05-.03c.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40,23.77s-.04-.03-.06-.04c.02.01.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.44,24.03s-.04-.02-.05-.03c.02,0,.04.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.77,23.59s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m39.88,23.68s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m43.45,24.21c.1-.04.2-.08.3-.12-.1.04-.2.08-.3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.29,23.95l-.04-.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.71,16.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.63,18.24s-.05,0-.07-.02h0s.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.25,18.14s-.06-.02-.09-.03h.02s.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.46,18.2s-.08-.02-.12-.03h.03s.06.02.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.02,18.3s-.03,0-.05,0h0s.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.8,18.27s-.04,0-.06,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m42.21,18.31s-.04,0-.05,0h.02s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.42,20.9s-.02-.07-.02-.11v-.03s-.01-.02-.01-.02c.01.07.02.13.04.19h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.46,21.04s-.02-.07-.03-.11c.02.06.04.12.06.18v-.04s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.97,21.84l-.03-.03s.09.08.14.12c-.03-.02-.06-.05-.09-.08l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41.18,22.02s-.06-.04-.09-.07h0s0,0,0,0c.05.04.1.07.15.11l-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.88,21.76s-.05-.06-.08-.09l-.02-.02-.03-.03c.06.07.12.14.18.21-.02-.02-.03-.03-.05-.05h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.63,21.42s-.03-.06-.05-.09v-.02s-.05-.07-.06-.11v-.02s-.02-.04-.03-.05c.04.12.1.23.17.34h0s-.01-.04-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.86,24.21s-.04-.01-.06-.02h.03s.03.02.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.72,24.15s-.04-.02-.06-.02h.02s.04.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m41,24.26s-.03-.01-.05-.02h.03s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m40.52,24.07h0s.03.02.05.03c-.02,0-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.23,11.04s-.05-.04-.08-.07l-.04-.04s-.05-.04-.07-.06c-.02-.01-.03-.02-.05-.04-.02-.02-.05-.04-.07-.05-.02-.01-.03-.02-.05-.03-.03-.02-.05-.04-.08-.05-.02,0-.03-.02-.05-.03-.02-.01-.05-.03-.07-.04.24.14.46.31.66.5-.02-.02-.04-.04-.06-.06l-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.45,13.15h0s0,.03.01.06h0s0-.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.37,11.17l-.03-.02s.06.05.08.08c-.02-.02-.03-.03-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.05,12.07v-.02s.02.05.03.08l-.02-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.48,11.29l-.03-.04s.05.05.08.08h-.01s-.03-.05-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.86,11.77s-.04-.05-.05-.08c-.01-.02-.02-.03-.04-.05-.01-.02-.03-.04-.04-.06.08.1.15.21.22.31-.02-.03-.03-.05-.05-.08-.01-.02-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.61,10.59s-.04-.02-.06-.03c.04.02.08.04.11.07h-.02s-.03-.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.48,13.31h0s0,.04.01.06h0s0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.54,13.98h0s0,.03,0,.05c0-.02,0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.58,11.4l-.03-.04s.05.06.07.08h0s-.04-.04-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.41,12.99s0,.04.01.06c0-.02,0-.03-.01-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m45.96,11.92s.03.06.05.08c-.01-.02-.02-.04-.03-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m46.12,12.21v-.02s.01.05.03.08h0s-.02-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "43.09 25.48 43.1 25.26 42.95 25.53 41.1 25.53 41.1 25.53 43.09 25.53 43.09 25.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m33.19,22.68c-.06-.12-.12-.24-.17-.35h0s-.02-.05-.02-.05h0s-.01-.03-.01-.03c-.02-.05-.05-.1-.07-.15v-.03s-.02-.01-.02-.01c0-.02-.02-.04-.03-.06h0s-.03-.08-.05-.12v-.02s-.02-.03-.02-.03c0-.02-.02-.04-.03-.06,0-.02-.01-.03-.02-.05,0-.02-.02-.04-.02-.06,0-.02-.02-.04-.02-.06h0s-.02-.05-.03-.07v-.02s-.02-.04-.03-.06c-.01-.03-.02-.06-.03-.09-.01-.03-.02-.06-.03-.09v-.04c-.04-.07-.06-.15-.09-.22h0c-.03-.09-.06-.19-.08-.28,0-.02-.01-.05-.02-.07h0c-.03-.09-.05-.19-.07-.28v-.03s-.01-.02-.01-.02c-.01-.05-.03-.11-.04-.16,0-.03-.02-.07-.02-.1-.01-.07-.03-.13-.04-.2,0-.02,0-.04-.01-.07-.02-.11-.04-.22-.06-.33,0-.03,0-.06-.01-.1,0-.03,0-.06-.01-.09,0-.04,0-.07-.01-.11,0-.05-.01-.1-.02-.15,0-.03,0-.07-.01-.1,0-.02,0-.05,0-.07v-.04s0-.01,0-.01v-.04s0,0,0,0h0s0-.06,0-.09c0-.03,0-.05,0-.08,0-.02,0-.03,0-.05h0c0-.07,0-.14-.01-.21,0-.02,0-.05,0-.07h0s0-.06,0-.08v-.03s0-.05,0-.08c0-.03,0-.05,0-.08v-.03s0-.06,0-.08c0-.06,0-.12,0-.19,0-.03,0-.06,0-.09,0-.09,0-.18,0-.28h0c0-.11.01-.21.02-.32v-.02c0-.1.02-.21.03-.31h0s-1.89,3.39-1.89,3.39h0c.01.09.03.17.05.26,0,.04.02.08.02.12.02.08.03.17.05.25,0,.03.01.05.02.08.04.16.08.33.12.49,0,.04.02.07.03.11.02.08.05.16.07.24.01.04.02.07.03.11.05.17.11.34.17.51v.02c.04.08.07.16.1.24.01.04.03.07.04.11.03.08.06.16.1.24l.02.04c.07.16.14.32.21.47.02.03.03.06.05.09.04.08.07.15.11.23.02.03.03.06.05.09.08.16.17.31.25.46l.02.03c.04.07.09.15.13.22.02.03.04.06.06.09.05.07.09.14.14.22h0s1.17-2.1,1.17-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m40.81,5.34c-1.1.3-2.16.71-3.14,1.25l-1.24,2.24h0c.2-.16.41-.3.62-.44h0c.21-.14.43-.27.65-.4h0c.22-.13.45-.24.68-.35h0c.23-.11.46-.21.7-.3h0c.24-.09.48-.18.72-.25h0c.24-.08.49-.14.74-.2h0c.5-.11,1.02-.19,1.54-.23h0l1.17-2.1c-.13,0-.26,0-.39,0-.1,0-.21,0-.31,0-.03,0-.07,0-.1,0-.07,0-.14,0-.2,0-.04,0-.08,0-.12,0-.06,0-.12,0-.18.01-.04,0-.09,0-.13.01-.06,0-.12.01-.18.02-.04,0-.09,0-.13.01-.06,0-.11.01-.17.02-.05,0-.09.01-.14.02-.06,0-.11.02-.17.02-.05,0-.09.01-.14.02-.05,0-.11.02-.16.03-.05,0-.09.02-.14.02-.05.01-.11.02-.16.03-.04,0-.09.02-.13.03-.05.01-.11.02-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.03-.05.01-.11.03-.16.04-.04.01-.09.02-.13.04-.05.02-.11.03-.16.05-.04.01-.08.03-.12.04-.06.02-.11.04-.17.06-.04.01-.08.03-.12.04-.06.02-.12.04-.18.07-.03.01-.07.02-.1.04-.08.03-.16.06-.25.1h-.03s-.35.64-.35.64c.91-.37,1.87-.62,2.84-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m35.21,25.37h0c-.08-.08-.17-.16-.25-.24h0c-.08-.08-.15-.16-.22-.24h0s0,0,0,0l-.04-.04h0s-.01-.01-.01-.01c-.05-.06-.11-.12-.16-.18h0s0,0,0,0c-.02-.02-.04-.04-.05-.06h0l-.02-.02c-.05-.06-.09-.11-.14-.17-.02-.02-.03-.04-.05-.06h-.01s-.01-.03-.01-.03c-.08-.11-.17-.21-.25-.32h0s-1.1,1.97-1.1,1.97c.1.12.2.23.3.35h0c.1.11.2.22.31.33h0c.1.12.21.22.32.32h.01c.11.12.22.22.34.32l1.04-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m43.6,6.65h0s.02,0,.02,0h.02s.06,0,.1.01h0c.05,0,.1,0,.15.02h0s.04,0,.06,0c.02,0,.04,0,.06,0h0s.04,0,.06,0c.03,0,.06,0,.09.01.04,0,.08.01.12.02h0s.1.01.14.02h0s.08.01.12.02c.05,0,.1.02.14.03.04,0,.08.02.12.02.04,0,.08.02.12.03h.02s0,0,0,0c.04,0,.08.02.12.03.05.01.1.02.14.03.04,0,.08.02.11.03.04.01.08.02.12.03l1.05-1.88h0c-.13-.04-.26-.08-.4-.12-.03,0-.06-.02-.08-.02-.13-.04-.26-.07-.39-.1h0c-.3-.07-.6-.13-.9-.18h0l-1.1,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m52.6,18.33h0c-.05.41-.13.82-.23,1.22h0s0,.01,0,.01h0c-.03.13-.07.26-.1.38h0s0,0,0,0h0c-.04.13-.07.25-.11.37v.04c-.05.12-.09.23-.13.35h0s0,.01,0,.01h0c-.04.12-.09.23-.13.35h0s-.02.04-.03.06c-.05.11-.09.23-.14.34l2.98-5.37c0-.06,0-.12,0-.17,0-.04,0-.07,0-.11,0-.08-.01-.16-.02-.24,0-.04,0-.08,0-.12,0-.02,0-.05,0-.07-.01-.12-.03-.24-.04-.36v-.04s-.01-.07-.02-.1c0-.03-.01-.06-.02-.09l-1.96,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m50.77,23.17h0c-.15.23-.32.45-.48.67h0s0,0,0,0h0c-.25.32-.52.63-.81.92h0s-.02.02-.02.02h0c-.18.19-.37.37-.57.54l-.03.02h0c-.1.09-.2.17-.3.25l-1.96,3.53c.2-.08.39-.17.59-.27h.01c.09-.05.18-.09.27-.14h.03c.1-.06.19-.11.28-.17l3-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m34.37,8.4c.44-.42.91-.81,1.41-1.16l.03-.02.4-.71h0c-.25.16-.5.33-.75.51h0c-.24.18-.48.37-.71.56h0s-.55.98-.55.98c.06-.06.11-.11.17-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m35.22,8.29c-.17.15-.34.31-.51.47-.63.61-1.2,1.27-1.71,1.99l-1.6,2.87c-.15.35-.29.71-.42,1.07.03-.17.06-.33.1-.5l-.94,1.69h0c-.02.12-.03.23-.05.35h0c-.01.12-.03.23-.04.34v.04c-.01.1-.02.2-.03.3,0,.02,0,.04,0,.06,0,.12-.01.24-.02.35h0c0,.12,0,.24,0,.36h0s5.22-9.4,5.22-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m36.88,29.02s.07.03.1.05c.02.01.05.02.07.03.09.04.19.08.28.12.02,0,.05.02.07.03.07.03.14.06.22.09.04.01.07.03.11.04.06.02.12.05.18.07.04.01.08.03.12.04.05.02.09.03.14.05h.03s.09.04.13.05c.03,0,.05.02.08.02.03,0,.06.02.09.03.04.01.09.03.13.04.06.02.11.03.17.05.05.01.09.02.14.03.06.01.11.03.17.04.03,0,.06.01.09.02.02,0,.03,0,.05.01.03,0,.06.01.09.02.03,0,.06.01.09.02.05,0,.09.02.14.03.06.01.12.02.17.03.05,0,.09.02.14.02.06,0,.12.02.18.03.05,0,.09.01.14.02.06,0,.12.02.18.02.02,0,.05,0,.07,0l1.12-2.01c-.13,0-.26-.01-.39-.02h-.03s0,0,0,0c-.26-.02-.52-.05-.78-.09h-.04c-.26-.05-.51-.1-.76-.16h-.03s0,0,0,0c-.12-.03-.24-.06-.37-.1h0s0,0,0,0c-.13-.04-.25-.08-.37-.12h0s-.01,0-.01,0h0c-.12-.04-.23-.08-.35-.12h0s-.03,0-.03,0c-.04-.01-.08-.03-.12-.05-.07-.03-.15-.06-.22-.09h-.03c-.23-.11-.46-.22-.68-.34h-.03c-.1-.07-.2-.12-.3-.18h-.01s0,0,0,0l-.03-.02h0s0,0,0,0c-.1-.06-.19-.12-.29-.18h-.02c-.11-.08-.21-.15-.31-.22h0c-.1-.07-.2-.14-.29-.22h0s0,0,0,0h-.01s-.02-.03-.02-.03c-.09-.07-.17-.13-.26-.2l-.02-.02-1.03,1.86c.23.18.46.34.7.5.03.02.07.04.1.07.06.04.13.08.19.12.09.06.19.11.28.17.04.02.08.05.12.07.08.04.15.08.23.13.04.02.07.04.11.06.11.06.23.12.34.17h0s.07.03.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m46.09,7.19s.09.03.14.05c.03.01.06.02.08.03.07.03.15.06.22.09h.02s0,0,0,0c.03.01.06.03.09.04.05.02.1.04.15.06.03.01.05.02.07.03h0c.05.03.1.05.15.07h0s.02,0,.02,0h.02s0,.01,0,.01c.08.04.17.08.25.13h0s.05.03.07.04h0c.08.04.16.09.25.14l.04.02h0s0,0,0,0h0c.07.04.15.09.22.13l.04.02s.05.03.07.04h0s.09.06.13.09c.04.03.08.05.13.08h.01c.09.07.18.13.26.19.02.01.03.02.05.03h.02s0,.01,0,.01h0c.08.06.15.11.22.17h0s.03.03.03.03c.08.07.17.13.25.2.02.02.04.03.06.05.07.06.14.12.2.18l.04.04s.08.08.13.12c.03.03.07.07.1.1h0s.04.04.05.05c.06.06.13.13.19.19.02.02.03.03.05.05l.02.02c.07.07.13.14.19.21h0s.03.03.04.05c.02.03.05.06.07.08.03.04.07.08.1.12h0s.02.03.02.03l.03.03c.05.06.09.12.14.17.02.03.04.05.06.08l.03.05c.05.06.09.12.13.19l.03.04h0s.03.04.05.07c.04.06.09.13.13.19l1.12-2.01s-.07-.09-.11-.14c-.02-.02-.04-.04-.05-.07h0s-.03-.05-.03-.05c-.06-.07-.11-.14-.17-.2-.02-.02-.04-.04-.05-.06-.08-.1-.17-.19-.25-.28-.02-.02-.04-.04-.06-.06-.07-.08-.15-.15-.22-.23-.02-.02-.04-.04-.06-.06-.09-.09-.18-.18-.27-.26l-.04-.03-.02-.02s-.08-.07-.12-.11c-.04-.04-.08-.07-.12-.11-.02-.02-.05-.04-.07-.06-.1-.08-.19-.16-.29-.24l-.04-.03c-.09-.07-.18-.14-.27-.21-.03-.02-.05-.04-.08-.06-.1-.08-.21-.15-.31-.22h-.02c-.07-.06-.14-.1-.2-.15-.03-.02-.07-.04-.1-.07-.03-.02-.06-.04-.09-.05-.1-.06-.21-.13-.31-.19h-.02c-.11-.08-.22-.14-.34-.2-.03-.02-.06-.03-.09-.05-.05-.03-.1-.05-.15-.08-.05-.03-.1-.05-.15-.08h0c-.13-.06-.25-.12-.38-.18-.03-.01-.06-.02-.08-.04-.13-.06-.26-.11-.39-.16l-1.03,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m51.61,12.14h0c.05.1.09.19.13.28v.02s.05.08.06.12c0,.02.01.03.02.05.01.02.02.05.03.07.01.02.02.05.03.08,0,.02.02.04.03.07.02.04.03.08.05.12v.04s.04.08.06.11l.02.04h0s0,0,0,0h0s0,.01,0,.01c.04.1.07.2.1.3,0,.03.02.06.03.08.03.08.05.16.08.24,0,.02.01.05.02.07.03.1.06.21.09.31,0,.02,0,.03.01.05.02.09.04.18.06.27,0,.03.01.05.02.08.02.1.04.2.06.3v.02c.02.11.04.22.06.33,0,.02,0,.04,0,.06.01.09.03.19.04.28,0,.02,0,.04,0,.06.01.11.02.23.03.35h0s1.55-2.79,1.55-2.79h0s-.01-.04-.01-.04v-.04c-.04-.11-.08-.21-.11-.32-.01-.03-.02-.06-.03-.09-.04-.13-.09-.25-.13-.37,0-.02-.01-.04-.02-.06-.04-.11-.08-.21-.13-.32-.01-.03-.03-.06-.04-.09-.05-.12-.1-.24-.16-.36v-.03c-.06-.11-.12-.22-.17-.33-.02-.03-.03-.06-.05-.09-.02-.04-.04-.07-.06-.11-.04-.08-.08-.15-.12-.23h0c-.06-.13-.13-.24-.19-.35-.02-.03-.03-.06-.05-.09-.05-.08-.1-.17-.16-.25l-1.18,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m46.6,26.89h0c-1.17.6-2.45.98-3.8,1.1l-1.18,2.12c.07,0,.14,0,.2,0,.13,0,.25,0,.38,0,.04,0,.07,0,.11,0,.09,0,.19,0,.28-.01.03,0,.07,0,.1,0,.12,0,.24-.02.36-.03h.01c.13-.01.26-.03.4-.05h.03c.12-.02.24-.04.36-.06h.04c.39-.08.78-.16,1.16-.27l1.55-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m37.97,6.05c-.21.09-.41.18-.62.28-.54.25-1.05.56-1.54.9l-.03.02c-.5.35-.97.74-1.41,1.16-.06.05-.11.11-.17.17-.8.8-1.49,1.72-2.03,2.72-.5.91-.87,1.89-1.09,2.9-.04.17-.07.33-.1.5.13-.36.27-.72.42-1.07.31-.74.68-1.45,1.1-2.13.16-.25.32-.5.49-.74.51-.71,1.08-1.38,1.71-1.99.16-.16.33-.32.51-.47.27-.23.54-.46.83-.67.47-.35.96-.67,1.47-.96.05-.03.1-.05.14-.08.98-.54,2.04-.95,3.14-1.25-.97.09-1.93.34-2.84.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 41.8,
    cy: 16.96,
    r: 8.85
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.10bbf3e1b4dc0435884164e3eeb1c08b.svg";
export { ForwardRef as ReactComponent };